/* eslint-disable */
/* tslint:disable */
// @ts-nocheck
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

export enum SubscriptionSubscriptionItemType {
  SubscriptionItemTypeGroup = "group",
  SubscriptionItemTypePlatform = "platform",
}

export enum SubscriptionInvoiceStatus {
  InvoiceStatusDraft = "draft",
  InvoiceStatusOpen = "open",
  InvoiceStatusPaid = "paid",
  InvoiceStatusUncollectible = "uncollectible",
  InvoiceStatusVoid = "void",
}

export enum PaymentWebhookWebhookEventStatus {
  StatusPending = "PENDING",
  StatusProcessing = "PROCESSING",
  StatusProcessed = "PROCESSED",
  StatusFailed = "FAILED",
  StatusIgnored = "IGNORED",
}

export enum PaymentWebhookPaymentProvider {
  ProviderStripe = "STRIPE",
}

export enum MatrixRoutesFreightMatrixPortCostFallbackFilter {
  FreightMatrixPortCostFallbackFilterVerified = "Verified",
  FreightMatrixPortCostFallbackFilterEstimatedAveragePort = "EstimatedAveragePort",
  FreightMatrixPortCostFallbackFilterEstimatedAverageCommodityPort = "EstimatedAverageCommodityPort",
  FreightMatrixPortCostFallbackFilterEstimatedAverageVesselPort = "EstimatedAverageVesselPort",
  FreightMatrixPortCostFallbackFilterEstimatedAverageVesselCommodityCountry = "EstimatedAverageVesselCommodityCountry",
  FreightMatrixPortCostFallbackFilterEstimatedAverageVesselCountry = "EstimatedAverageVesselCountry",
  FreightMatrixPortCostFallbackFilterEstimatedAverageVesselCommodityGlobal = "EstimatedAverageVesselCommodityGlobal",
  FreightMatrixPortCostFallbackFilterEstimatedAverageVesselGlobal = "EstimatedAverageVesselGlobal",
  FreightMatrixPortCostFallbackFilterEstimatedAverageCommodityGlobal = "EstimatedAverageCommodityGlobal",
  FreightMatrixPortCostFallbackFilterEstimatedClosestCoasterCommodityOperation = "EstimatedClosestCoasterCommodityOperation",
  FreightMatrixPortCostFallbackFilterEstimatedClosestCoasterCommodity = "EstimatedClosestCoasterCommodity",
  FreightMatrixPortCostFallbackFilterEstimatedAverageCoasterPort = "EstimatedAverageCoasterPort",
  FreightMatrixPortCostFallbackFilterFallbackCoaster = "FallbackCoaster",
}

export enum JobRunnersJobStatus {
  JobStatusPending = "pending",
  JobStatusActive = "active",
  JobStatusFinished = "finished",
  JobStatusFailed = "failed",
}

export enum FreightJobPhase {
  JobPhaseQueued = "queued",
  JobPhaseCalculating = "calculating",
  JobPhasePublishing = "publishing",
  JobPhaseAvailable = "available",
}

export enum FrcApiCalculationGranularity {
  CalculationGranularityMonth = "Month",
  CalculationGranularityWeek = "Week",
  CalculationGranularityDay = "Day",
}

export enum FrcApiCalculationContext {
  CalculationContextSpot = "Spot",
  CalculationContextHistorical = "Historical",
}

export enum WeatherImageFileType {
  WeatherImageFileTypePast = "past",
  WeatherImageFileTypeForecast = "forecast",
}

export enum VesselType {
  VesselHandysize = "Handysize",
  VesselSupramax = "Supramax",
  VesselPanamax = "Panamax",
}

export enum UserRole {
  UserRoleADMIN = "ADMIN",
  UserRoleSALESPERSON = "SALESPERSON",
  UserRoleRESEARCHER = "RESEARCHER",
  UserRoleBROKER = "BROKER",
  UserRoleCMUSER = "CM_USER",
  UserRoleUSER = "USER",
}

export enum SupplyDemandUploadAvailability {
  SupplyDemandUploadAvailabilityActivating = "activating",
  SupplyDemandUploadAvailabilityActive = "active",
  SupplyDemandUploadAvailabilityDraft = "draft",
  SupplyDemandUploadAvailabilityPublished = "published",
}

export enum SelfCheckoutSubscriptionType {
  SelfCheckoutSubscriptionTypeSINGLEGROUP = "SINGLE_GROUP",
  SelfCheckoutSubscriptionTypeMULTIPLEGROUPS = "MULTIPLE_GROUPS",
  SelfCheckoutSubscriptionTypePLATFORM = "PLATFORM",
}

export enum SelfCheckoutSubscriptionStatus {
  SelfCheckoutSubscriptionStatusPENDING = "PENDING",
  SelfCheckoutSubscriptionStatusACTIVE = "ACTIVE",
  SelfCheckoutSubscriptionStatusPASTDUE = "PAST_DUE",
  SelfCheckoutSubscriptionStatusCANCELED = "CANCELED",
  SelfCheckoutSubscriptionStatusEXPIRED = "EXPIRED",
  SelfCheckoutSubscriptionStatusPAUSED = "PAUSED",
  SelfCheckoutSubscriptionStatusTRIALING = "TRIALING",
}

export enum PriceType {
  PriceTypeFLAT = "FLAT",
  PriceTypePREMIUM = "PREMIUM",
}

export enum PlatformMenuVariant {
  PlatformMenuVariantSTANDARD = "STANDARD",
  PlatformMenuVariantONLYFREIGHT = "ONLY_FREIGHT",
}

export enum MeasurementUnitType {
  MeasurementUnitTypeVOLUME = "VOLUME",
  MeasurementUnitTypeWEIGHT = "WEIGHT",
  MeasurementUnitTypeLENGTH = "LENGTH",
  MeasurementUnitTypeTIME = "TIME",
  MeasurementUnitTypeAREA = "AREA",
}

export enum FreightCalculatorCalculationContext {
  FreightCalculatorCalculationContextSpot = "Spot",
  FreightCalculatorCalculationContextHistorical = "Historical",
}

export enum Firmness {
  FirmnessINTEREST = "INTEREST",
  FirmnessQUOTE = "QUOTE",
  FirmnessFIRM = "FIRM",
}

export enum CadenceInputType {
  CadenceInputTypeMTSDAY = "MTS_DAY",
  CadenceInputTypeHOURS = "HOURS",
}

export enum BidOfferType {
  BidOfferTypeBID = "BID",
  BidOfferTypeOFFER = "OFFER",
}

export enum BidOfferStatus {
  StatusActive = "ACTIVE",
  StatusClosed = "CLOSED",
  StatusExpiring = "EXPIRING",
  StatusExpired = "EXPIRED",
}

export enum BidOfferConfidential {
  BidOfferConfidentialPRICE = "PRICE",
  BidOfferConfidentialCLIENT = "CLIENT",
}

export enum BidOfferCloseReason {
  BidOfferCloseReasonAUTOEXPIRATION = "AUTO_EXPIRATION",
  BidOfferCloseReasonCLOSED = "CLOSED",
  BidOfferCloseReasonCLOSEDTRADEDBYCM = "CLOSED_TRADED_BY_CM",
  BidOfferCloseReasonCLOSEDTRADEDBYCOMPETITION = "CLOSED_TRADED_BY_COMPETITION",
  BidOfferCloseReasonCLOSEDWITHDRAWNBYCLIENT = "CLOSED_WITHDRAWN_BY_CLIENT",
}

export interface BaseOriginResponse {
  countryIds: number[];
  locationCollectionsIds: number[];
}

export interface BasePortInput {
  /** LocationCollections is a list of names */
  locationCollections: string[];
  /** Ports is a list on unlocodes */
  ports: string[];
  /** used to convert between different domains if return measurement unit issnt the same as the defined base location */
  product: string;
  quantityMt: number;
  returnCurrency: string;
  returnMeasurementUnit: string;
}

export interface BasePortResponse {
  /** CurrencyId that the baseport is defined in */
  currencyId: number;
  /** FreightDiff as it was defined in the database */
  freightDiff: number;
  /** LocationCollectionIds is the ids there wasn't overridden together with the overridden base locations */
  locationCollectionIds: number[];
  /** MeasurementUnitId that the baseport is defined in */
  measurementUnitId: number;
  /** NormalizedCurrencyId is what currency id there was requested */
  normalizedCurrencyId: number;
  /** NormalizedFreightDiff is the freightdiff in the currency/measurementunit there was requested */
  normalizedFreightDiff: number;
  /** MeasurementUnitId is what measurement unit there was requested */
  normalizedMeasurementUnitId: number;
  /** PortIds is the ids there wasn't overridden together with the overridden base locations */
  portIds: number[];
  /** Product there was requested */
  productId: number;
  /** QuantityMaximumLimitMt is the maximum threshold for when the provided FreightDiff applies */
  quantityMaximumLimitMt: number;
}

export interface BidOfferComments {
  count: number;
}

export interface CFRRate {
  dischargeLocation: LocationDTO;
  loadData: CFRRateLoad[];
  productGrouping: string;
  vesselType: VesselType;
}

export interface CFRRateData {
  freightPrice: UnitPriceDTO;
  intakeQuantity: MeasurementDTO;
  /** @format date-time */
  maturity: string;
  nominalPrice: NominalPriceValue;
}

export interface CFRRateFilterOptions {
  dischargeCountry: FacetCountryDTO[];
  dischargePort: FacetPortDTO[];
  loadCountry: FacetCountryDTO[];
  loadPort: FacetPortDTO[];
  product: FacetProductDTO[];
  productGrouping: FacetRawTextFilterDTO[];
  proteinLevel: FacetPercentageDTO[];
  vesselType: FacetRawTextFilterDTO[];
}

export interface CFRRateLoad {
  cfrId: string;
  loadLocation: LocationDTO;
  nominalPriceInstance: DimensionDTO;
  nominalPriceType: PriceType;
  priceData: CFRRateData[];
  productHierarchyInstance: ProductDTO;
  /** @format int64 */
  proteinLevelPercentage: number | null;
  /** @format int64 */
  proteinLevelPercentageUs: number | null;
  voyageId: string;
}

export interface CFRRateResponse {
  data: CFRRate[];
  filterOptions: CFRRateFilterOptions;
  pagination: PaginationDTO;
}

export interface ChangeLog {
  externalPriceInstance: boolean;
  firmness: boolean;
  internalPriceInstance: boolean;
  shipmentPeriodEnd: boolean;
  shipmentPeriodStart: boolean;
}

export interface CountryDTO {
  alpha2Code: string;
  alpha3Code: string;
  displayName: string;
  id: number;
  isoName: string;
  isoNumeric: string;
}

export interface CurrencyDTO {
  displayName: string;
  displaySymbol: string;
  id: number;
  name: string;
}

export interface D365CrmAccount {
  accountId: string;
  accountName: string;
  accountNumber: number;
  country: string | null;
  url: string;
}

export interface DimensionDTO {
  displayName: string;
  id: number;
  name: string;
}

export interface ErrorResponse {
  /** @example "userId must be a string" */
  error: string;
}

export interface ExchangeRate {
  fromCurrency: number;
  toCurrency: number;
  /** contains the oldest timestamp of the two rates used */
  tradeTimestamp: string;
  value: number;
}

export interface ExchangeRateHistorical {
  data: ExchangeRateHistoricalData[];
  exchangeRateInstance: ExchangeRateInstanceDTO;
}

export interface ExchangeRateHistoricalData {
  tradingDay: string;
  value: ExchangeRateHistoricalValue;
}

export interface ExchangeRateHistoricalValue {
  close: number;
  high: number;
  low: number;
  open: number;
  volume: number;
}

export interface ExchangeRateInstanceDTO {
  displayName: string;
  fromCurrency: CurrencyDTO;
  id: number;
  name: string;
  toCurrency: CurrencyDTO;
}

export interface ExchangeRateLive {
  exchangeRateInstance: ExchangeRateInstanceDTO;
  serverTimestamp: string;
  tradeTimestamp: string;
  updatedAt: string;
  value: ExchangeRateLiveValue;
}

export interface ExchangeRateLiveValue {
  high: number;
  lastPrice: number;
  low: number;
  netChange: number;
  open: number;
  percentChange: number;
  volume: number;
}

export interface ExchangeRatesForwardLiveFRC {
  fromCurrency: string;
  /** @format int64 */
  lastPriceUSD: number | null;
  /** @format date */
  maturity: string | null;
  /** @format date-time */
  tradeTimestamp: string | null;
}

export interface ExchangeRatesHistoricalOverview {
  earliestTradingDayAvailable: string;
  exchangeRateInstance: ExchangeRateInstanceDTO;
  latestTradingDayAvailable: string;
}

export interface ExchangeRatesLiveFRC {
  fromCurrency: string;
  /** @format int64 */
  lastPriceUSD: number | null;
  /** @format date-time */
  tradeTimestamp: string | null;
}

export interface FacetCountryDTO {
  displayName: string;
  key: string;
}

export interface FacetFrcIdDTO {
  displayName: string;
  key: string;
}

export interface FacetPercentageDTO {
  displayName: string;
  key: string;
}

export interface FacetPortDTO {
  displayName: string;
  key: string;
}

export interface FacetProductDTO {
  displayName: string;
  key: string;
}

export interface FacetRawTextFilterDTO {
  displayName: string;
  key: string;
}

export interface FeatureFlagDataRowWithDescription {
  active: boolean;
  /** @format date-time */
  createdAt: string | null;
  defaultValue: boolean;
  description: string;
  disabled: boolean;
  flagKey: string;
  team_targets: number[];
  /** @format date-time */
  updatedAt: string | null;
  user_targets: string[];
}

export interface FeatureFlagSavePayload {
  default_value: boolean;
  disabled: boolean;
  flag_key: string;
  team_targets: number[];
  user_targets: string[];
}

export interface FlatPrice {
  currencyId: number;
  /** CODECOMMENT should have been wrapped so price would be on the same level as the normalized price */
  flatPrice: number;
  /** FreightDiff calculated from baseport in the same currency as FlatPrice */
  freightDiff: number;
  measurementUnitId: number;
  normalized: NormalizedFlatPrice;
}

export interface FlatUpdate {
  changeLog: ChangeLog;
  /** @format date-time */
  createdAt: string | null;
  createdByUser: User;
  externalFlat: FlatPrice;
  firmness: Firmness;
  id: number;
  /** FreightDiff in InternalFlatPrice .NormalizedFlat is always null, internal always null for external version */
  internalFlat: FlatPrice;
  /** @format date */
  shipmentPeriodEnd: string | null;
  /** @format date */
  shipmentPeriodStart: string | null;
}

export interface FreightCalculationMinimalParams {
  calculationId: string;
  planId: string;
}

export interface FreightMatrix {
  ballastBonus: PgtypeFloat8;
  calculationId: string;
  calculationJobId: string;
  commercialPostBallastPortDisplayName: string | null;
  /** @format int64 */
  commercialPostBallastPortId: number | null;
  commercialPostBallastPortName: string | null;
  commercialPreBallastPortDisplayName: string | null;
  /** @format int64 */
  commercialPreBallastPortId: number | null;
  commercialPreBallastPortName: string | null;
  dischargeCountryDisplayName: string;
  dischargeCountryId: number;
  dischargeCountryName: string;
  dischargePortDisplayName: string;
  dischargePortId: number;
  dischargePortName: string;
  dischargeRate: number;
  dischargeRegionDisplayName: string | null;
  /** @format int64 */
  dischargeRegionId: number | null;
  dischargeRegionName: string | null;
  dischargeTerms: string;
  frcId: string;
  freightrateUsd: number;
  intakeQuantity: number;
  loadCountryDisplayName: string;
  loadCountryId: number;
  loadCountryName: string;
  loadPortDisplayName: string;
  loadPortId: number;
  loadPortName: string;
  loadRate: number;
  loadRegionDisplayName: string | null;
  /** @format int64 */
  loadRegionId: number | null;
  loadRegionName: string | null;
  loadTerms: string;
  lsmgoPrice: number;
  /** @format date */
  maturity: string | null;
  overrides: number[];
  planId: string;
  sailingDays: number;
  tcRate: number;
  teamIds: number[];
  /** @format date-time */
  updatedAt: string | null;
  vesselType: string;
  voyageDays: number;
  /** @example "vesselsize-loadunlo-dischargeunlo-comodity" */
  voyageId: string;
  vsfloPrice: number;
}

export interface FreightRate {
  commodity: string;
  dischargeLocation: LocationDTO;
  loadLocation: LocationDTO;
  priceData: FreightRateData[];
  /** @format date-time */
  updatedAt: string;
  vesselType: VesselType;
  voyageId: string;
}

export interface FreightRateCalculation {
  ballastBonus: PriceDTO;
  dischargeRate: MeasurementRateDTO;
  dischargeTerms: string;
  intakeQuantity: MeasurementDTO;
  loadRate: MeasurementRateDTO;
  loadTerms: string;
  lsmgoPrice: UnitPriceDTO;
  sailingDays: MeasurementDTO;
  tcRate: UnitPriceDTO;
  voyageDays: MeasurementDTO;
  vsfloPrice: UnitPriceDTO;
}

export interface FreightRateData {
  calculation: FreightRateCalculation;
  /** @format date-time */
  maturity: string;
  price: UnitPriceDTO;
}

export interface FreightRateFilterOptions {
  commodity: FacetFrcIdDTO[];
  dischargeCountry: FacetCountryDTO[];
  dischargePort: FacetPortDTO[];
  loadCountry: FacetCountryDTO[];
  loadPort: FacetPortDTO[];
  vesselType: FacetRawTextFilterDTO[];
}

export interface FreightRateResponse {
  data: FreightRate[];
  filterOptions: FreightRateFilterOptions;
  pagination: PaginationDTO;
}

export interface Future {
  currencyId: number;
  futureContractInstanceId: number;
  futureInstanceId: number;
  measurementUnitId: number;
}

export interface FutureContractInstanceDTO {
  activeMonths: string | null;
  contractSize: string | null;
  currency: CurrencyDTO;
  dailyLimit: string | null;
  displayName: string;
  futureOptionSize: string | null;
  futureUnitSize: string | null;
  id: number;
  lastTradingDay: string | null;
  measurementUnit: MeasurementUnitDTO;
  name: string;
  productName: string | null;
  tickSize: string | null;
  tradingHours: string | null;
}

export interface FutureInstanceDTO {
  displayName: string;
  expirationDate: string;
  futureContractInstance: FutureContractInstanceDTO;
  id: number;
  month: number;
  monthIdentifier: string;
  name: string;
  year: number;
}

export interface FuturePrice {
  futureInstanceId: number;
  tradeTimestamp: string;
  value: number;
}

export interface FuturePriceLive {
  futureInstance: FutureInstanceDTO;
  serverTimestamp: string;
  tradeTimestamp: string;
  updatedAt: string;
  value: FuturePriceLiveValue;
}

export interface FuturePriceLiveValue {
  high: number;
  lastPrice: number;
  low: number;
  netChange: number;
  open: number;
  openInterest: number;
  percentChange: number;
  volume: number;
}

export interface FuturePriceNearestHistorical {
  data: FuturePriceNearestHistoricalData[];
  futureContractInstance: FutureContractInstanceDTO;
}

export interface FuturePriceNearestHistoricalData {
  futureInstance: FutureInstanceDTO;
  tradingDay: string;
  value: FuturePriceNearestHistoricalValue;
}

export interface FuturePriceNearestHistoricalOverview {
  earliestTradingDayAvailable: string;
  futureContractInstance: FutureContractInstanceDTO;
  latestTradingDayAvailable: string;
}

export interface FuturePriceNearestHistoricalValue {
  close: number;
  high: number;
  low: number;
  open: number;
  openInterest: number;
  volume: number;
}

export interface GetAggregatedUsageByApiRoute {
  avg_duration_ms: number;
  /** @format date-time */
  bucket_start: string;
  count_4xx: number;
  count_5xx: number;
  endpoint: string;
  error_ratio: number;
  max_duration_ms: number;
  method: string;
  min_duration_ms: number;
  p50_duration_ms: number;
  p90_duration_ms: number;
  p95_duration_ms: number;
  p99_duration_ms: number;
  req_count: number;
}

export interface GetAllAccessLogsByApiInstance {
  acceptHeader: string;
  /** @format int64 */
  apiInstanceId: number | null;
  /** @format date-time */
  createdAt: string | null;
  durationMs: number;
  encodingHeader: string;
  endpoint: any;
  id: string;
  ip: string;
  method: string;
  /** @format int64 */
  noOfRecords: number | null;
  statusCode: number;
  url: string;
}

export interface GetLastUsageByApiRoute {
  endpoint: any;
  last_used: any;
  method: string;
}

export interface GetStandardRatesByVoyageIDsRequest {
  voyage_ids: string[];
}

export interface GetStandardRatesByVoyageIDsResponse {
  /**
   * AlternativeRates contains alternative route options when there are multiple rates
   * for the same voyage ID AND maturity combination. The key is "{voyageID}|{maturity}"
   * where maturity is in YYYY-MM-DD format. The system picks the one with minimal overrides
   * as the standard rate, and alternatives are stored here.
   */
  alternative_rates: Record<string, FreightMatrix[]>;
  errors: StandardRateFetchFailure[];
  /**
   * StandardRates contains the selected rates for each voyage ID.
   * Each voyage ID maps to an array of rates (one per maturity).
   */
  standard_rates: Record<string, FreightMatrix[]>;
}

export interface InternalBidAndOffer {
  /** @format date-time */
  archivedAt: string | null;
  baseOrigin: BaseOriginResponse;
  basePort: BasePortResponse;
  bidOfferType: BidOfferType;
  closeReason: BidOfferCloseReason;
  comments: BidOfferComments;
  confidentialityList: BidOfferConfidential[];
  /** @format date-time */
  createdAt: string | null;
  createdByUser: User;
  d365CrmAccount: D365CrmAccount;
  /** @format int64 */
  documentRequirementId: number | null;
  /** @format date-time */
  expiresAt: string | null;
  externalNote: string | null;
  flatPriceInformation: FlatUpdate;
  id: number;
  internalNote: string | null;
  originCountryIdList: number[];
  originLocationCollectionIdList: number[];
  parityId: number;
  portIdList: number[];
  portLocationCollectionIdList: number[];
  premiumPriceInformation: PremiumUpdate;
  /** both can be exported, internal is just null for external api */
  priceType: PriceType;
  productInstanceId: number;
  /** @format int64 */
  proteinLevelPercentage: number | null;
  /** @format int64 */
  qualityRequirementId: number | null;
  /** @format int64 */
  quantityMT: number | null;
  responsibleBrokers: User[];
  showExternal: boolean;
  status: BidOfferStatus;
  /** @format date-time */
  updatedAt: string | null;
}

export interface InternalBidAndOfferHistorical {
  bidOfferType: BidOfferType;
  confidentiality: BidOfferConfidential[];
  /** @format date-time */
  createdAt: string | null;
  d365CrmAccount: D365CrmAccount;
  /** @format date */
  date: string | null;
  /** @format int64 */
  documentRequirementId: number | null;
  externalNote: string | null;
  externalOriginCountryIdList: number[];
  externalOriginLocationCollectionIdList: number[];
  externalPortIdList: number[];
  externalPortLocationCollectionIdList: number[];
  externalPriceQuote: PriceQuote;
  firmness: Firmness;
  id: number;
  internalNote: string | null;
  internalPriceQuote: PriceQuote;
  normalizedFreightDiff: Price;
  originCountryIdList: number[];
  originLocationCollectionIdList: number[];
  parityId: number;
  portIdList: number[];
  portLocationCollectionIdList: number[];
  priceType: PriceType;
  productInstanceId: number;
  /** @format int64 */
  proteinLevelPercentage: number | null;
  /** @format int64 */
  qualityRequirementId: number | null;
  /** @format int64 */
  quantityMT: number | null;
  responsibleBrokers: User[];
  shipmentPeriod: ShipmentPeriod;
  showExternal: boolean;
}

export interface InternalBidAndOfferMatchingResult {
  /** @format date-time */
  archivedAt: string | null;
  baseOrigin: BaseOriginResponse;
  basePort: BasePortResponse;
  bidOfferType: BidOfferType;
  closeReason: BidOfferCloseReason;
  comments: BidOfferComments;
  confidentialityList: BidOfferConfidential[];
  /** @format date-time */
  createdAt: string | null;
  createdByUser: User;
  d365CrmAccount: D365CrmAccount;
  /** @format int64 */
  documentRequirementId: number | null;
  /** @format date-time */
  expiresAt: string | null;
  externalNote: string | null;
  flatPriceInformation: FlatUpdate;
  id: number;
  internalNote: string | null;
  matching: MatchingInfo;
  originCountryIdList: number[];
  originLocationCollectionIdList: number[];
  parityId: number;
  portIdList: number[];
  portLocationCollectionIdList: number[];
  premiumPriceInformation: PremiumUpdate;
  /** both can be exported, internal is just null for external api */
  priceType: PriceType;
  productInstanceId: number;
  /** @format int64 */
  proteinLevelPercentage: number | null;
  /** @format int64 */
  qualityRequirementId: number | null;
  /** @format int64 */
  quantityMT: number | null;
  responsibleBrokers: User[];
  showExternal: boolean;
  status: BidOfferStatus;
  /** @format date-time */
  updatedAt: string | null;
}

export interface InternalBidAndOfferPlatform {
  bidOfferType: BidOfferType;
  /** @format date-time */
  createdAt: string | null;
  id: number;
  /** external note on the bid/offer */
  note: string;
  /**
   * todo group the next 2 into 1 struct
   * baseorigin info used when applicable, else the defined origin
   */
  originCountryIdList: number[];
  /** baseorigin info used when applicable, else the defined originlocation collection */
  originLocationCollectionIdList: number[];
  parityId: number;
  /**
   * todo group the next 2 into 1 struct
   * baseport info used when applicable, else the defined port
   */
  portIdList: number[];
  /** baseport info used when applicable, else the defined location collection */
  portLocationCollectionIdList: number[];
  /**
   * the original external premium entered by the broker, included the potential freightdiff in currency/unit defined by the future
   * the original external flat price entered by the broker, included the potential freightdiff in currency/unit defined by the broker
   * the premium or flatprice converted to usd/mt included the potential freightdiff
   */
  priceQuote: PriceQuote;
  priceType: PriceType;
  /** todo group the next 3 into 1 struct */
  productInstanceId: number;
  /** @format int64 */
  proteinLevelPercentage: number | null;
  /** @format int64 */
  quantityMT: number | null;
  /** taken from latest price update */
  shipmentPeriod: ShipmentPeriod;
}

export interface LocationCollectionDTO {
  displayName: string;
  id: number;
  name: string;
}

export interface LocationDTO {
  country: CountryDTO;
  port: PortDTO;
  region: LocationCollectionDTO;
}

export interface MatchingInfo {
  originCountryId: number[];
  originLocationCollectionId: number[];
  overlap: MatchingShipmentPeriodOverlap;
  portId: number[];
  portLocationCollectionId: number[];
  score: number;
}

export interface MatchingShipmentPeriodOverlap {
  end: string;
  start: string;
}

export interface MeasurementDTO {
  measurementUnit: MeasurementUnitDTO;
  value: number;
}

export interface MeasurementRateDTO {
  measurementUnitDenominator: MeasurementUnitDTO;
  measurementUnitNumerator: MeasurementUnitDTO;
  value: number;
}

export interface MeasurementUnitDTO {
  displayName: string;
  displayNameShort: string;
  id: number;
  name: string;
  unitType: MeasurementUnitType;
}

export interface NominalPriceActiveUpload {
  id: number;
}

export interface NominalPriceData {
  /** @format date-time */
  maturity: string;
  price: NominalPriceValue;
}

export interface NominalPriceFilterOptions {
  country: FacetCountryDTO[];
  port: FacetPortDTO[];
  product: FacetProductDTO[];
  productGrouping: FacetRawTextFilterDTO[];
  proteinLevel: FacetPercentageDTO[];
}

export interface NominalPriceRate {
  loadData: NominalPriceRateLoad[];
  productGrouping: string;
}

export interface NominalPriceRateLoad {
  /** @format date-time */
  createdAt: string;
  location: LocationDTO;
  nominalPriceInstance: DimensionDTO;
  priceData: NominalPriceData[];
  priceType: PriceType;
  product: ProductDTO;
  /** @format int64 */
  proteinLevelPercentage: number | null;
  /** @format int64 */
  proteinLevelPercentageUs: number | null;
  /** @format date-time */
  publishedAt: string;
}

export interface NominalPriceResponse {
  data: NominalPriceRate[];
  filterOptions: NominalPriceFilterOptions;
  pagination: PaginationDTO;
}

export interface NominalPriceValue {
  flatPrice: UnitPriceDTO;
  premium: PremiumDTO;
}

export interface NormalizedFlatPrice {
  currencyExchangeRateToUsd: number;
  currencyExchangeRateUsdToTarget: number;
  /** target CurrencyId */
  currencyId: number;
  currencyRateTarget: number;
  /** target currency with freight diff applied if applicable */
  flatPrice: number;
  /** FreightDiff based on baseport logic in target CurrencyId and MeasurementUnitId */
  freightDiff: number;
  /** FuturePrice is only null for flat price calculations */
  futurePrice: number;
  /** target MeasurementUnitId */
  measurementUnitId: number;
}

export interface NormalizedPrice {
  exchangeRate: ExchangeRate;
  futurePrice: FuturePrice;
  price: Price;
}

export interface PaginationDTO {
  page: number;
  pageSize: number;
  totalItems: number;
  totalPages: number;
}

export interface PortDTO {
  country: CountryDTO;
  displayName: string;
  id: number;
  unlocode: string;
}

export interface Premium {
  futureInstanceId: number;
  value: number;
}

export interface PremiumDTO {
  futureInstance: FutureInstanceDTO;
  value: number;
}

export interface PremiumPrice {
  /** FreightDiff calculated from baseport in the same currency as PremiumPrice/ Future */
  freightDiff: number;
  future: Future;
  normalized: NormalizedFlatPrice;
  /** CODECOMMENT should have been wrapped so price would be on the same level as the normalized price */
  premiumPrice: number;
}

export interface PremiumUpdate {
  changeLog: ChangeLog;
  /** @format date-time */
  createdAt: string | null;
  createdByUser: User;
  externalPremium: PremiumPrice;
  firmness: Firmness;
  id: number;
  /** FreightDiff in InternalPremiumPrice .NormalizedFlat is always null, internal always null for external version */
  internalPremium: PremiumPrice;
  /** @format date */
  shipmentPeriodEnd: string | null;
  /** @format date */
  shipmentPeriodStart: string | null;
}

export interface Price {
  currencyId: number;
  measurementUnitId: number;
  value: number;
}

export interface PriceDTO {
  currency: CurrencyDTO;
  value: number;
}

export interface PriceQuote {
  flatPrice: Price;
  /** is optional to be able to return the parent object even if a price couldn't be calculated */
  normalizedFlatPrice: NormalizedPrice;
  premium: Premium;
}

export interface ProductDTO {
  density: MeasurementRateDTO;
  displayName: string;
  id: number;
  name: string;
}

export interface RouteRole {
  method: string;
  permission: string;
  route: string;
}

export interface RussianTax {
  date: string;
  taxBarley: number;
  taxCorn: number;
  taxWheat: number;
}

export interface ShipmentPeriod {
  /** @format date */
  end: string | null;
  /** @format date */
  start: string | null;
}

export interface StandardRateFetchFailure {
  error: string;
  voyage_id: string;
}

export interface SupplyAndDemandProduct {
  id: number;
  name: string;
}

export interface SupplyAndDemandUploadHistoryResponseItem {
  availability: SupplyDemandUploadAvailability;
  id: number;
  jobId: number;
  products: SupplyAndDemandProduct[];
  updatedAt: string;
}

export interface UnitPriceDTO {
  currency: CurrencyDTO;
  measurementUnit: MeasurementUnitDTO;
  value: number;
}

export interface User {
  firstName: string;
  id: string;
  lastName: string;
}

export interface Vessel {
  imo: number;
  marineTrafficId: number;
  name: string;
}

export interface VesselResponse {
  data: Vessel[];
  pagination: PaginationDTO;
}

export interface WeatherImageFile {
  BlobPath: string;
  /** @format date */
  DateKey: string | null;
  Group: string;
  ImageName: string;
  /** @format int64 */
  ImageVersion: number | null;
  Label: string;
  RegionCode: string;
  RegionLabel: string;
  Type: WeatherImageFileType;
  /** @format date-time */
  updatedAt: string | null;
}

export interface AuthUserInfo {
  currentSubscription: AuthUserInfoSubscription;
  email: string;
  enabledFeatureFlags: string[];
  id: string;
  name: string;
  permissions: string[];
  role: UserRole;
  teamId: number;
  teamName: string;
  trackingId: string;
}

export interface AuthUserInfoSubscription {
  currentSubscription: string;
  endDate: string;
  isTrial: boolean;
  menuVariant: PlatformMenuVariant;
  startDate: string;
}

export interface FrcApiMinimalCalculationPlan {
  baseDate?: string | null;
  /** @format uuid */
  calculationId: string;
  cargoIntake?: number | null;
  dischargeDisplayName?: string | null;
  dischargeUnlocode?: string | null;
  freightRate?: number | null;
  granularity?: "Day" | "Week" | "Month" | null;
  loadDisplayName?: string | null;
  loadUnlocode?: string | null;
  /** @format uuid */
  planId: string;
}

export interface FrcApiPartialTriggerData {
  jobId?: string;
  matrixIdsMatched: number;
  matrixIdsRequested: number;
  parentJobId?: string;
  routesToCalculate: number;
  waitingForParentJob: boolean;
}

export interface FrcApiPartialTriggerResponse {
  data: FrcApiPartialTriggerData;
  message: string;
}

export interface FrcApiPrecalcRouteInput {
  commodity: string;
  dischargePort: string;
  loadPort: string;
}

export interface FrcApiPrecalculateJobRef {
  alreadyRunning?: boolean;
  jobId: string;
}

export interface FrcApiPrecalculateRequest {
  chunkRoutes?: number;
  /** @example "Spot" */
  context: FrcApiCalculationContext;
  count?: number;
  endDate?: string;
  /** @example "Month" */
  granularity?: FrcApiCalculationGranularity;
  matrixIds: number[];
  routes?: FrcApiPrecalcRouteInput[];
  saveRouteRate?: boolean;
  startDate?: string;
}

export interface FrcApiPrecalculateSuccessResponse {
  data: FrcApiPrecalculateJobRef;
}

export interface FrcApiVesselResponse {
  DWT: number;
  beam: number;
  consumptionBallastEcoMTDay: number;
  consumptionBallastFullMTDay: number;
  consumptionLadenEcoMTDay: number;
  consumptionLadenFullMTDay: number;
  displayName: string;
  ffaProductCode: string;
  gears: number;
  grainCft: number;
  holds: number;
  ladenDraftSW: number;
  lengthOverAll: number;
  portIdleMTDay: number;
  portWorkingMTDay: number;
  showInSimpleMode: boolean;
  showWhenQuantityAboveX?: number;
  showWhenQuantityBelowX?: number;
  speedBallastEcoNMhour: number;
  speedBallastFullNMHour: number;
  speedLadenEcoNMhour: number;
  speedLadenFullNMhour: number;
  tonnesPerCentimeter: number;
  vessel: string;
}

export interface FreightJobProgress {
  calculationErrorRate: number;
  /**
   * Completion is the bar, 0..100. The engine's own progress fills the first 80, a finished job
   * waits at 85 until its rows are served, and 100 means the team can read them.
   */
  completion: number;
  context: "Spot" | "Historical";
  createdAt: string;
  finishedAt?: string | null;
  id: string;
  parentJobId?: string | null;
  phase: "queued" | "calculating" | "publishing" | "available";
  progress: number;
  /** Served is true once the job's rows are in the serving database, which the matrix reads from. */
  served: boolean;
  startedAt?: string | null;
  status: "Queued" | "Calculating" | "Done";
  taskErrorRate: number;
  type: "Manual" | "PreCalculate" | "User" | "PreCalculatePartial";
  waitingForParentJob: boolean;
}

export interface FreightPrecalculatePartialRequest {
  count?: number;
  parentJobId?: string;
  teamId: number;
}

export interface FreightRouteAvailabilityRequest {
  algorithms: string[];
  commodity: string;
  dischargePorts: string[];
  loadPorts: string[];
  shipSizes: string[];
}

export type GinH = Record<string, any>;

export interface HighlightsMarketInformationItem {
  category: string;
  content?: Record<string, any> | null;
  id: string;
  title: string;
}

export interface HighlightsMarketInformationPost {
  content?: Record<string, any> | null;
  createdAt: string;
  id: number;
  items: HighlightsMarketInformationItem[];
  publishedAt: string;
  tags: string[];
  thumbnailUrl?: string | null;
  title: string;
  type: "marketInformation" | "dailySummary";
}

/** Standard error response with an error message and optional trace ID for debugging */
export interface HttpHelpersErrorResponse {
  /** @example "Something went wrong" */
  error: string;
  /** @example "abc123-def456-789" */
  traceId?: string;
}

export interface JobRunnersJobIdentifier {
  /** JobID the id from the app database */
  job_id: number;
  /** JobType is the kind of job, eg "synapse" or "fabricNotebook" or "fabricPipeline" */
  job_type: string;
  /** ProviderId is base64 encoded id from the job provider */
  provider_id: string;
}

export interface JobsJobProgressResponse {
  /** Error if failed */
  error: string;
  job_identifier: JobRunnersJobIdentifier;
  progress: number;
  status: JobRunnersJobStatus;
}

export type JobsStartJobPayload = Record<string, any>;

export interface MarketInformationPruneRequest {
  /** Every post of this kind that Payload has. All other posts of the kind are removed. */
  keepIds: number[];
  kind: string;
  /** Only posts published before this time are removed. */
  publishedBefore: string;
}

export interface MarketInformationPruneResponse {
  removed: number;
}

export interface MarketInformationPublishRequest {
  post: HighlightsMarketInformationPost;
  searchText: string;
}

export interface MatrixRoutesRouteData {
  FK_Commodity: string;
  FK_DischargePort: string;
  FK_LoadPort: string;
  Id: number;
  algorithms?: MatrixRoutesFreightMatrixPortCostFallbackFilter[];
  context: FreightCalculatorCalculationContext;
  dischargeCadence?: number;
  dischargeCadenceInputType?: CadenceInputType;
  dischargeDraft?: number;
  dischargePortDA?: number;
  dischargePortDACurrency?: string;
  dischargeTerms?: string;
  dischargeUseVesselGear?: boolean;
  loadCadence?: number;
  loadCadenceInputType?: CadenceInputType;
  loadDraft?: number;
  loadPortDA?: number;
  loadPortDACurrency?: string;
  loadTerms?: string;
  loadUseVesselGear?: boolean;
  stowageFactor?: number;
  stowageFactorUnit?: string;
  vesselSize: string;
}

export interface NotificationsNotificationSuccessResponse {
  /** @example "ok" */
  status: string;
}

export interface PaymentAvailableGroupResponse {
  description: string;
  emailEnabled: boolean;
  id: number;
  isFree: boolean;
  name: string;
}

export interface PaymentAvailableGroupsListResponse {
  count: number;
  groups: PaymentAvailableGroupResponse[];
}

export interface PaymentCancelMarketReportSubscriptionsForUserParams {
  userId: string;
}

export interface PaymentCancelMarketReportSubscriptionsForUserResult {
  cancelledCount: number;
}

export interface PaymentCancelSubscriptionRequest {
  cancelImmediately: boolean;
  reason?: string;
}

export interface PaymentConfirmSubscriptionChangeRequest {
  items: SubscriptionCreateSubscriptionItem[];
}

export interface PaymentCreatePlatformSubscriptionWithPaymentParams {
  paymentMethodId: string;
  platformSubscriptionPriceId: number;
}

export interface PaymentEmailDeliveryStatusResponse {
  assignedMarketReportTemplateId?: number | null;
  emailEnabled: boolean;
  hasReportAccess: boolean;
  marketReportGroupId: number;
  receivesEmail: boolean;
  templates: PaymentEmailDeliveryTemplateStatusResponse[];
  userId: string;
}

export interface PaymentEmailDeliveryTemplateStatusResponse {
  isAllowed: boolean;
  marketReportTemplateId: number;
  priority: number;
}

export interface PaymentEmailPreferenceResponse {
  emailEnabled: boolean;
  id: number;
  marketReportGroupId: number;
  marketReportGroupName: string;
  userId: string;
}

export interface PaymentEmailPreferencesListResponse {
  count: number;
  preferences: PaymentEmailPreferenceResponse[];
}

export interface PaymentEnableAllPurchasedEmailPreferencesResponse {
  enabledCount: number;
  message: string;
}

export interface PaymentMarketReportSubscriberResponse {
  email: string;
  firstName: string;
  lastName: string;
  userId: string;
}

export interface PaymentMarketReportSubscribersListResponse {
  count: number;
  subscribers: PaymentMarketReportSubscriberResponse[];
}

export interface PaymentMessageResponse {
  /** @example "Operation completed successfully" */
  message: string;
}

export interface PaymentPaymentMethodAttachRequest {
  /** @example "pm_1234567890" */
  paymentMethodId: string;
}

export interface PaymentPaymentMethodAttachResponse {
  /** @example "Payment method attached successfully" */
  message: string;
}

export interface PaymentPaymentMethodConfirmRequest {
  /** @example "seti_1234567890" */
  setupIntentId: string;
}

export interface PaymentPaymentMethodConfirmResponse {
  /** @example "Payment method confirmed successfully" */
  message: string;
  /** @example "seti_1234567890" */
  setupIntentId: string;
}

export interface PaymentPaymentMethodsResponse {
  /** @example 2 */
  count: number;
  paymentMethods: SubscriptionPaymentMethodData[];
}

export interface PaymentSetVatNumberRequest {
  /** @example "EU123456789" */
  vatNumber: string;
}

export interface PaymentSetVatNumberResponse {
  /** @example "VAT number set successfully" */
  message: string;
  /** @example "txi_1234567890" */
  taxId?: string;
}

export interface PaymentSetupIntentResponse {
  /** @example "seti_1234567890_secret_abcdef" */
  clientSecret: string;
  /** @example "seti_1234567890" */
  setupIntentId: string;
}

export interface PaymentSyncCustomerResponse {
  customerId: string;
  message: string;
  providerId: string;
  success: boolean;
}

export interface PaymentUpdateEmailPreferenceRequest {
  emailEnabled: boolean;
}

export interface PaymentUpdateEmailPreferenceResponse {
  emailEnabled: boolean;
  id: number;
  marketReportGroupId: number;
  marketReportGroupName?: string;
  message: string;
  userId: string;
}

export interface PaymentWebhookEventStats {
  failedCount: number;
  ignoredCount: number;
  pendingCount: number;
  processedCount: number;
  processingCount: number;
}

export interface PaymentWebhookStoredWebhookEvent {
  createdAt: string;
  customerId?: number;
  eventTimestamp: string;
  eventType: string;
  id: number;
  invoiceId?: number;
  maxRetries: number;
  nextRetryAt?: string;
  payload: number[];
  paymentId?: number;
  processedAt?: string;
  processedResult?: number[];
  processingError?: string;
  provider: PaymentWebhookPaymentProvider;
  providerEventId: string;
  receivedAt: string;
  retryCount: number;
  signature?: string;
  signatureVerified: boolean;
  status: PaymentWebhookWebhookEventStatus;
  subscriptionId?: number;
  verifiedAt?: string;
}

export interface PaymentWebhooksListWebhooksResponse {
  events: PaymentWebhookStoredWebhookEvent[];
  limit: number;
  offset: number;
  total: number;
}

export interface PgtypeFloat8 {
  /** @format float64 */
  float64?: number;
  valid?: boolean;
}

export interface RecaptchaVerifyRequest {
  expectedAction: string;
  token: string;
}

export interface RecaptchaVerifyResult {
  reasons: string[];
  score: number;
}

export interface SubscriptionCancelSubscriptionResult {
  /** CancelAtPeriodEnd indicates if the subscription will cancel at period end */
  cancelAtPeriodEnd: boolean;
  /** CanceledAt is the timestamp when the subscription was canceled (if immediate) */
  canceledAt?: string;
  /** CurrentPeriodEnd is when the subscription will end (if cancel at period end) */
  currentPeriodEnd: string;
  /** ID of the canceled subscription */
  id: number;
  /** Status is the new subscription status */
  status: SelfCheckoutSubscriptionStatus;
}

export interface SubscriptionConfirmSubscriptionChangeResult {
  /** Currency for all amounts */
  currency: string;
  /** EffectiveDate is when the change took effect */
  effectiveDate: string;
  /** ImmediateCharge is the amount charged/credited immediately for proration */
  immediateCharge: number;
  /** Items lists the new subscription items */
  items: SubscriptionSubscriptionItemData[];
  /** NewPrice is the new recurring price after the change */
  newPrice: number;
  /** NextBillingDate is when the next regular billing will occur */
  nextBillingDate: string;
  /** PreviousPrice is what the subscription price was before the change */
  previousPrice: number;
  /** Status is the subscription status after the change */
  status: SelfCheckoutSubscriptionStatus;
  /** SubscriptionID is the ID of the modified subscription */
  subscriptionId: number;
}

export interface SubscriptionCreateSubscriptionItem {
  priceId: number;
  priceType: SubscriptionSubscriptionItemType;
}

export interface SubscriptionCreateSubscriptionResultData {
  id: number;
  providerId: string;
  status: SelfCheckoutSubscriptionStatus;
}

export interface SubscriptionCreateWithPaymentParams {
  items: SubscriptionCreateSubscriptionItem[];
  /** provider payment method id - must be set up separately first */
  paymentMethodId: string;
}

export interface SubscriptionCreateWithPaymentResult {
  clientSecret?: string | null;
  requiresAction: boolean;
  subscription: SubscriptionCreateSubscriptionResultData;
  success: boolean;
}

export interface SubscriptionCustomerSummaryData {
  email?: string | null;
  id: number;
  name?: string | null;
  userId: string;
}

export interface SubscriptionInvoiceData {
  amountDue: number;
  amountPaid: number;
  /**
   * AttemptCount is Stripe's invoice.attempt_count — how many times the
   * provider has tried to charge this invoice. 0 for invoices that have
   * not been attempted (e.g. drafts, upcoming).
   */
  attemptCount: number;
  currency: string;
  downloadURL?: string | null;
  dueDate?: string | null;
  /**
   * NextPaymentAttempt is Stripe's invoice.next_payment_attempt — when the
   * provider will next auto-retry a failed charge. Nil once the provider
   * has exhausted its retry schedule or the invoice has been resolved.
   */
  nextPaymentAttempt?: string | null;
  /** automatically generated invoice number */
  number: string;
  paidAt?: string | null;
  periodEnd: string;
  periodStart: string;
  /** ID in the provider system */
  providerId: string;
  status: SubscriptionInvoiceStatus;
  /**
   * SubscriptionProviderID is the provider's subscription ID (e.g. Stripe
   * "sub_…") this invoice was generated for, or nil for one-off invoices.
   * Exposed so the frontend can join an open invoice to a subscription
   * without calling Stripe directly.
   */
  subscriptionProviderId?: string | null;
  totalAmount: number;
}

export interface SubscriptionInvoiceStats {
  currency: string;
  paidInvoices: number;
  totalInvoices: number;
  totalPaid: number;
  totalUnpaid: number;
  unpaidInvoices: number;
}

export interface SubscriptionInvoicesResult {
  invoices: SubscriptionInvoiceData[];
  stats: SubscriptionInvoiceStats;
}

export interface SubscriptionPaymentMethodData {
  cardBrand: string;
  cardExpMonth: number;
  cardExpYear: number;
  cardLast4: string;
  /** Used for non-card payment methods */
  fallbackDisplayName: string;
  /** ID in the provider system */
  id: string;
  isDefault: boolean;
  type: string;
}

export interface SubscriptionPreviewLineItem {
  amount: number;
  currency: string;
  description: string;
  /** PriceID is the Stripe price ID if applicable */
  priceId?: string;
  /** Proration indicates if this is a proration adjustment */
  proration: boolean;
}

export interface SubscriptionPreviewSubscriptionChange {
  items: SubscriptionCreateSubscriptionItem[];
}

export interface SubscriptionProviderSyncInstructions {
  /** If `All` is true, all items should be synced */
  all: boolean;
  /** Individual items to sync with the payment provider */
  items: SubscriptionProviderSyncItem[];
}

export interface SubscriptionProviderSyncItem {
  /** @format int32 */
  id?: number;
  /** "MarketReportGroupPrice" */
  type?: string;
}

export interface SubscriptionReactivateSubscriptionResult {
  /** CurrentPeriodEnd is when the current billing period ends */
  currentPeriodEnd: string;
  /** CurrentPeriodStart is when the current billing period started */
  currentPeriodStart: string;
  /** ID of the reactivated subscription */
  id: number;
  /** Status is the new subscription status (should be ACTIVE) */
  status: SelfCheckoutSubscriptionStatus;
}

export interface SubscriptionSubscriptionChangePreview {
  /** Currency for all amounts */
  currency: string;
  /** CurrentItems lists items currently on the subscription */
  currentItems: SubscriptionSubscriptionItemData[];
  /** CurrentPrice is the current recurring price of the subscription */
  currentPrice: number;
  /**
   * ImmediateCharge is the amount that will be charged immediately (positive = charge, negative = credit)
   * This includes prorations for the current billing period
   */
  immediateCharge: number;
  /** ImmediateTax is the tax amount included in the immediate charge */
  immediateTax: number;
  /** ImmediateTaxDescription describes the tax on the immediate charge (e.g., "Estonia VAT 20%") */
  immediateTaxDescription?: string;
  /** LineItems shows the breakdown of the preview invoice */
  lineItems: SubscriptionPreviewLineItem[];
  /** NewItems lists items that will be on the subscription after the change */
  newItems: SubscriptionSubscriptionItemData[];
  /** NewPrice is what the recurring price will be after the change */
  newPrice: number;
  /** NextBillingDate is when the next regular billing will occur */
  nextBillingDate: string;
  /** NextMonthlyTax is the estimated tax on the next monthly bill */
  nextMonthlyTax: number;
  /** NextMonthlyTotal is the total next monthly bill including tax */
  nextMonthlyTotal: number;
  /** ProrationDate is when the proration is calculated from */
  prorationDate: string;
  /** SubscriptionID is the ID of the subscription being modified */
  subscriptionId: number;
}

export interface SubscriptionSubscriptionCostPreview {
  /** BillingInterval indicates the billing frequency (e.g., "MONTHLY") */
  billingInterval: string;
  /** Currency for all amounts */
  currency: string;
  /** Items lists the subscription items in the preview */
  items: SubscriptionSubscriptionItemData[];
  /** LineItems shows the breakdown of subscription items */
  lineItems: SubscriptionPreviewLineItem[];
  /** Subtotal is the recurring price before taxes */
  subtotal: number;
  /** Tax is the estimated tax amount (VAT, sales tax, etc.) */
  tax: number;
  /** TaxDescription describes the tax being applied (e.g., "VAT", "Estonia VAT 20%") */
  taxDescription?: string;
  /** TaxRate is the tax rate percentage applied (e.g., 0.20 for 20%) */
  taxRate: number;
  /** Total is the total recurring price including taxes */
  total: number;
}

export interface SubscriptionSubscriptionData {
  cancelAtPeriodEnd: boolean;
  cancelReason: string;
  canceledAt: string;
  currentCurrency: string;
  currentPeriodEnd: string;
  currentPeriodStart: string;
  currentPrice: number;
  customer: SubscriptionCustomerSummaryData;
  displayName: string;
  id: number;
  itemCount: number;
  items: SubscriptionSubscriptionItemData[];
  status: SelfCheckoutSubscriptionStatus;
  subscriptionType: SelfCheckoutSubscriptionType;
}

export interface SubscriptionSubscriptionItemData {
  id: number;
  name: string;
  price: number;
  priceId: number;
  type: SubscriptionSubscriptionItemType;
}

export interface TextToBidsOffersFlatPrice {
  currency: TextToBidsOffersIdDisplayName;
  price: number;
  unit: TextToBidsOffersIdDisplayName;
}

export interface TextToBidsOffersIdDisplayName {
  display_name: string;
  id: string;
}

export interface TextToBidsOffersMappingErrors {
  error: string;
  field: string;
}

export interface TextToBidsOffersPostInput {
  broker: string;
  text: string;
}

export interface TextToBidsOffersPremiumPrice {
  exchange_market: TextToBidsOffersIdDisplayName;
  future_contract_instance: TextToBidsOffersIdDisplayName;
  future_instance: TextToBidsOffersIdDisplayName;
  premium: number;
}

export interface TextToBidsOffersTrade {
  bidOfferType: BidOfferType;
  confidential: boolean;
  /** Origins both contains Countries and LocationCollection entities, countries ids prefixed with "country:", locationCollections prefixed with "lc:" */
  origins: TextToBidsOffersIdDisplayName[];
  paper_terms: TextToBidsOffersIdDisplayName;
  parity: TextToBidsOffersIdDisplayName;
  populationErrors: TextToBidsOffersMappingErrors[];
  /** Ports both contains Port and LocationCollection entities, port ids prefixed with "port:", locationCollections prefixed with "lc:" */
  ports: TextToBidsOffersIdDisplayName[];
  priceInfoFlat: TextToBidsOffersFlatPrice;
  priceInfoPremium: TextToBidsOffersPremiumPrice;
  priceType: PriceType;
  productInstance: TextToBidsOffersIdDisplayName;
  proteinLevel: number;
  quantity: number;
  shipmentFrom: string;
  shipmentTo: string;
}

export type QueryParamsType = Record<string | number, any>;
export type ResponseFormat = keyof Omit<Body, "body" | "bodyUsed">;

export interface FullRequestParams extends Omit<RequestInit, "body"> {
  /** set parameter to `true` for call `securityWorker` for this request */
  secure?: boolean;
  /** request path */
  path: string;
  /** content type of request body */
  type?: ContentType;
  /** query params */
  query?: QueryParamsType;
  /** format of response (i.e. response.json() -> format: "json") */
  format?: ResponseFormat;
  /** request body */
  body?: unknown;
  /** base url */
  baseUrl?: string;
  /** request cancellation token */
  cancelToken?: CancelToken;
}

export type RequestParams = Omit<
  FullRequestParams,
  "body" | "method" | "query" | "path"
>;

export interface ApiConfig<SecurityDataType = unknown> {
  baseUrl?: string;
  baseApiParams?: Omit<RequestParams, "baseUrl" | "cancelToken" | "signal">;
  securityWorker?: (
    securityData: SecurityDataType | null,
  ) => Promise<RequestParams | void> | RequestParams | void;
  customFetch?: typeof fetch;
}

export interface HttpResponse<D extends unknown, E extends unknown = unknown>
  extends Response {
  data: D;
  error: E;
}

type CancelToken = Symbol | string | number;

export enum ContentType {
  Json = "application/json",
  JsonApi = "application/vnd.api+json",
  FormData = "multipart/form-data",
  UrlEncoded = "application/x-www-form-urlencoded",
  Text = "text/plain",
}

export class HttpClient<SecurityDataType = unknown> {
  public baseUrl: string = "";
  private securityData: SecurityDataType | null = null;
  private securityWorker?: ApiConfig<SecurityDataType>["securityWorker"];
  private abortControllers = new Map<CancelToken, AbortController>();
  private customFetch = (...fetchParams: Parameters<typeof fetch>) =>
    fetch(...fetchParams);

  private baseApiParams: RequestParams = {
    credentials: "same-origin",
    headers: {},
    redirect: "follow",
    referrerPolicy: "no-referrer",
  };

  constructor(apiConfig: ApiConfig<SecurityDataType> = {}) {
    Object.assign(this, apiConfig);
  }

  public setSecurityData = (data: SecurityDataType | null) => {
    this.securityData = data;
  };

  protected encodeQueryParam(key: string, value: any) {
    const encodedKey = encodeURIComponent(key);
    return `${encodedKey}=${encodeURIComponent(typeof value === "number" ? value : `${value}`)}`;
  }

  protected addQueryParam(query: QueryParamsType, key: string) {
    return this.encodeQueryParam(key, query[key]);
  }

  protected addArrayQueryParam(query: QueryParamsType, key: string) {
    const value = query[key];
    return value.map((v: any) => this.encodeQueryParam(key, v)).join("&");
  }

  protected toQueryString(rawQuery?: QueryParamsType): string {
    const query = rawQuery || {};
    const keys = Object.keys(query).filter(
      (key) => "undefined" !== typeof query[key],
    );
    return keys
      .map((key) =>
        Array.isArray(query[key])
          ? this.addArrayQueryParam(query, key)
          : this.addQueryParam(query, key),
      )
      .join("&");
  }

  protected addQueryParams(rawQuery?: QueryParamsType): string {
    const queryString = this.toQueryString(rawQuery);
    return queryString ? `?${queryString}` : "";
  }

  private contentFormatters: Record<ContentType, (input: any) => any> = {
    [ContentType.Json]: (input: any) =>
      input !== null && (typeof input === "object" || typeof input === "string")
        ? JSON.stringify(input)
        : input,
    [ContentType.JsonApi]: (input: any) =>
      input !== null && (typeof input === "object" || typeof input === "string")
        ? JSON.stringify(input)
        : input,
    [ContentType.Text]: (input: any) =>
      input !== null && typeof input !== "string"
        ? JSON.stringify(input)
        : input,
    [ContentType.FormData]: (input: any) => {
      if (input instanceof FormData) {
        return input;
      }

      return Object.keys(input || {}).reduce((formData, key) => {
        const property = input[key];
        formData.append(
          key,
          property instanceof Blob
            ? property
            : typeof property === "object" && property !== null
              ? JSON.stringify(property)
              : `${property}`,
        );
        return formData;
      }, new FormData());
    },
    [ContentType.UrlEncoded]: (input: any) => this.toQueryString(input),
  };

  protected mergeRequestParams(
    params1: RequestParams,
    params2?: RequestParams,
  ): RequestParams {
    return {
      ...this.baseApiParams,
      ...params1,
      ...(params2 || {}),
      headers: {
        ...(this.baseApiParams.headers || {}),
        ...(params1.headers || {}),
        ...((params2 && params2.headers) || {}),
      },
    };
  }

  protected createAbortSignal = (
    cancelToken: CancelToken,
  ): AbortSignal | undefined => {
    if (this.abortControllers.has(cancelToken)) {
      const abortController = this.abortControllers.get(cancelToken);
      if (abortController) {
        return abortController.signal;
      }
      return void 0;
    }

    const abortController = new AbortController();
    this.abortControllers.set(cancelToken, abortController);
    return abortController.signal;
  };

  public abortRequest = (cancelToken: CancelToken) => {
    const abortController = this.abortControllers.get(cancelToken);

    if (abortController) {
      abortController.abort();
      this.abortControllers.delete(cancelToken);
    }
  };

  public request = async <T = any, E = any>({
    body,
    secure,
    path,
    type,
    query,
    format,
    baseUrl,
    cancelToken,
    ...params
  }: FullRequestParams): Promise<HttpResponse<T, E>> => {
    const secureParams =
      ((typeof secure === "boolean" ? secure : this.baseApiParams.secure) &&
        this.securityWorker &&
        (await this.securityWorker(this.securityData))) ||
      {};
    const requestParams = this.mergeRequestParams(params, secureParams);
    const queryString = query && this.toQueryString(query);
    const payloadFormatter = this.contentFormatters[type || ContentType.Json];
    const responseFormat = format || requestParams.format;

    return this.customFetch(
      `${baseUrl || this.baseUrl || ""}${path}${queryString ? `?${queryString}` : ""}`,
      {
        ...requestParams,
        headers: {
          ...(requestParams.headers || {}),
          ...(type && type !== ContentType.FormData
            ? { "Content-Type": type }
            : {}),
        },
        signal:
          (cancelToken
            ? this.createAbortSignal(cancelToken)
            : requestParams.signal) || null,
        body:
          typeof body === "undefined" || body === null
            ? null
            : payloadFormatter(body),
      },
    ).then(async (response) => {
      const r = response as HttpResponse<T, E>;
      r.data = null as unknown as T;
      r.error = null as unknown as E;

      const responseToParse = responseFormat ? response.clone() : response;
      const data = !responseFormat
        ? r
        : await responseToParse[responseFormat]()
            .then((data) => {
              if (r.ok) {
                r.data = data;
              } else {
                r.error = data;
              }
              return r;
            })
            .catch((e) => {
              r.error = e;
              return r;
            });

      if (cancelToken) {
        this.abortControllers.delete(cancelToken);
      }

      if (!response.ok) throw data;
      return data;
    });
  };
}

/**
 * @title No title
 * @contact
 */
export class Api<
  SecurityDataType extends unknown,
> extends HttpClient<SecurityDataType> {
  internal = {
    /**
     * No description
     *
     * @tags Bids and Offers
     * @name TextToBidsOfferCreate
     * @request POST:/internal/text_to_bids_offer
     */
    textToBidsOfferCreate: (
      data: TextToBidsOffersPostInput,
      params: RequestParams = {},
    ) =>
      this.request<TextToBidsOffersTrade[], any>({
        path: `/internal/text_to_bids_offer`,
        method: "POST",
        body: data,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Nominal Prices
     * @name NominalPricesList
     * @request GET:/internal/nominal_prices
     */
    nominalPricesList: (
      query: {
        country_name_list?: string[];
        nominal_price_instance_name_list?: string[];
        page: number;
        page_size: number;
        port_name_list?: string[];
        product_grouping_list?: string[];
        product_hierachy_instance_name_list?: string[];
        protein_level_list?: number[];
        text_search?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<NominalPriceResponse, any>({
        path: `/internal/nominal_prices`,
        method: "GET",
        query: query,
        ...params,
      }),

    /**
     * No description
     *
     * @name D365CrmAccountsList
     * @request GET:/internal/d365_crm_accounts
     */
    d365CrmAccountsList: (params: RequestParams = {}) =>
      this.request<D365CrmAccount[], any>({
        path: `/internal/d365_crm_accounts`,
        method: "GET",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Weather Maps
     * @name WeatherMapsList
     * @request GET:/internal/weather_maps
     */
    weatherMapsList: (params: RequestParams = {}) =>
      this.request<WeatherImageFile[], any>({
        path: `/internal/weather_maps`,
        method: "GET",
        ...params,
      }),

    /**
     * No description
     *
     * @name RussianTaxList
     * @request GET:/internal/russian_tax
     */
    russianTaxList: (
      query: {
        days_back: number;
      },
      params: RequestParams = {},
    ) =>
      this.request<RussianTax[], any>({
        path: `/internal/russian_tax`,
        method: "GET",
        query: query,
        ...params,
      }),

    /**
     * No description
     *
     * @name VesselList
     * @request GET:/internal/vessel
     */
    vesselList: (
      query: {
        page: number;
        page_size: number;
        text_search?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<VesselResponse, any>({
        path: `/internal/vessel`,
        method: "GET",
        query: query,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Bids and Offers
     * @name BidsAndOffersList
     * @request GET:/internal/bids_and_offers
     */
    bidsAndOffersList: (
      query?: {
        bid_offer_type?: string;
        close_reason?: string[];
        document_requirement_id?: number[];
        limit?: number;
        offset?: number;
        origin_country_id?: number[];
        origin_country_location_collection_id?: number[];
        parity_id?: number[];
        port_country_id?: number[];
        port_id?: number[];
        port_location_collection_id?: number[];
        product_instance_id?: number[];
        protein_level?: number[];
        quality_requirement_id?: number[];
        responsible_broker_id?: string[];
        text_search?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<InternalBidAndOffer[], any>({
        path: `/internal/bids_and_offers`,
        method: "GET",
        query: query,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Feature Flags
     * @name FeatureFlagsList
     * @request GET:/internal/feature_flags
     */
    featureFlagsList: (params: RequestParams = {}) =>
      this.request<FeatureFlagDataRowWithDescription[], any>({
        path: `/internal/feature_flags`,
        method: "GET",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Feature Flags
     * @name FeatureFlagsUpdate
     * @request PUT:/internal/feature_flags
     */
    featureFlagsUpdate: (
      feature_flags: FeatureFlagSavePayload[],
      params: RequestParams = {},
    ) =>
      this.request<FeatureFlagDataRowWithDescription[], any>({
        path: `/internal/feature_flags`,
        method: "PUT",
        body: feature_flags,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags CFR
     * @name GetInternal
     * @request GET:/internal/cfr
     */
    getInternal: (
      query: {
        discharge_country_name_list?: string[];
        discharge_port_name_list?: string[];
        discharge_region_name_list?: string[];
        load_country_name_list?: string[];
        load_port_name_list?: string[];
        load_region_name_list?: string[];
        nominal_price_instance_name_list?: string[];
        page: number;
        page_size: number;
        product_grouping_list?: string[];
        product_hierachy_instance_name_list?: string[];
        protein_level_list?: number[];
        team_id: number;
        text_search?: string;
        vessel_type?: string[];
      },
      params: RequestParams = {},
    ) =>
      this.request<CFRRateResponse[], any>({
        path: `/internal/cfr`,
        method: "GET",
        query: query,
        ...params,
      }),

    /**
     * No description
     *
     * @name AllRegisteredApiRolesList
     * @request GET:/internal/all_registered_api_roles
     */
    allRegisteredApiRolesList: (params: RequestParams = {}) =>
      this.request<RouteRole[], any>({
        path: `/internal/all_registered_api_roles`,
        method: "GET",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Freight
     * @name FreightList
     * @request GET:/internal/freight
     */
    freightList: (
      query: {
        commodity_list?: string[];
        discharge_country_name_list?: string[];
        discharge_port_name_list?: string[];
        load_country_name_list?: string[];
        load_port_name_list?: string[];
        page: number;
        page_size: number;
        team_id: number;
        text_search?: string;
        vessel_type_list?: string[];
      },
      params: RequestParams = {},
    ) =>
      this.request<FreightRateResponse[], any>({
        path: `/internal/freight`,
        method: "GET",
        query: query,
        ...params,
      }),

    /**
     * No description
     *
     * @name MatrixRoutesActiveList
     * @request GET:/internal/matrix_routes/active
     */
    matrixRoutesActiveList: (params: RequestParams = {}) =>
      this.request<MatrixRoutesRouteData[], any>({
        path: `/internal/matrix_routes/active`,
        method: "GET",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Nominal Prices
     * @name NominalPricesActiveList
     * @summary Returns the upload id of the nominal price upload there is in use / is active
     * @request GET:/internal/nominal_prices/active
     */
    nominalPricesActiveList: (params: RequestParams = {}) =>
      this.request<NominalPriceActiveUpload, any>({
        path: `/internal/nominal_prices/active`,
        method: "GET",
        ...params,
      }),

    /**
     * @description Cancels all active SINGLE_GROUP/MULTIPLE_GROUPS subscriptions for the given user. Used by the admin sales-team flow after granting a platform subscription that supersedes them. Admin route (mounted outside the per-user X-User-Id middleware, like the email subscribers admin route); FE handles admin role gating before calling.
     *
     * @tags Payment
     * @name PaymentAdminCancelMarketReportSubscriptionsForUserCreate
     * @summary Cancel a user's active market report subscriptions (admin)
     * @request POST:/internal/payment/admin/cancel-market-report-subscriptions-for-user
     */
    paymentAdminCancelMarketReportSubscriptionsForUserCreate: (
      request: PaymentCancelMarketReportSubscriptionsForUserParams,
      params: RequestParams = {},
    ) =>
      this.request<PaymentCancelMarketReportSubscriptionsForUserResult, string>(
        {
          path: `/internal/payment/admin/cancel-market-report-subscriptions-for-user`,
          method: "POST",
          body: request,
          type: ContentType.Json,
          format: "json",
          ...params,
        },
      ),

    /**
     * No description
     *
     * @tags Access Logs
     * @name AccessLogsAggregatedDetail
     * @request GET:/internal/access_logs/aggregated/{apiinstanceid}
     */
    accessLogsAggregatedDetail: (
      apiinstanceid: number,
      query: {
        /**
         * From time expression
         * @example "now-7d"
         */
        from: string;
        /**
         * To time expression
         * @example "now"
         */
        to: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<GetAggregatedUsageByApiRoute[], any>({
        path: `/internal/access_logs/aggregated/${apiinstanceid}`,
        method: "GET",
        query: query,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Access Logs
     * @name AccessLogsAllDetail
     * @request GET:/internal/access_logs/all/{apiinstanceid}
     */
    accessLogsAllDetail: (
      apiinstanceid: number,
      query: {
        /**
         * Time expression or ISO timestamp
         * @example "now-7d"
         */
        from: string;
        /**
         * Time expression or ISO timestamp
         * @example "now"
         */
        to: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<GetAllAccessLogsByApiInstance[], any>({
        path: `/internal/access_logs/all/${apiinstanceid}`,
        method: "GET",
        query: query,
        ...params,
      }),

    /**
     * @description Returns supply and demand uploads in descending creation date order, along with a list of products in the upload and whether the upload is active, published or a draft
     *
     * @tags Supply And Demand
     * @name SupplyAndDemandBackofficeUploadHistoryList
     * @summary List supply and demand uploads
     * @request GET:/internal/supply_and_demand/backoffice/upload-history
     */
    supplyAndDemandBackofficeUploadHistoryList: (
      query: {
        is_eu: boolean;
        limit?: number;
        offset?: number;
      },
      params: RequestParams = {},
    ) =>
      this.request<SupplyAndDemandUploadHistoryResponseItem[], any>({
        path: `/internal/supply_and_demand/backoffice/upload-history`,
        method: "GET",
        query: query,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Bids and Offers
     * @name BidsAndOffersBaseportPreviewCreate
     * @request POST:/internal/bids_and_offers/baseport/preview
     */
    bidsAndOffersBaseportPreviewCreate: (
      data: BasePortInput,
      params: RequestParams = {},
    ) =>
      this.request<BasePortResponse, any>({
        path: `/internal/bids_and_offers/baseport/preview`,
        method: "POST",
        body: data,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @name MatrixRoutesByIdsDetail
     * @request GET:/internal/matrix_routes/by-ids/{ids}
     */
    matrixRoutesByIdsDetail: (ids: string, params: RequestParams = {}) =>
      this.request<MatrixRoutesRouteData[], any>({
        path: `/internal/matrix_routes/by-ids/${ids}`,
        method: "GET",
        ...params,
      }),

    /**
     * @description Get minimal freight calculation data (rate, intake, base date, granularity, load and discharge port) for the given calculation and plan IDs. Read from the FRC engine (POST /api/v1/calculation-results/minimal); pairs that no longer resolve to a saved plan are left out of the response.
     *
     * @tags Freight
     * @name FreightCalculationsMinimalCreate
     * @request POST:/internal/freight/calculations/minimal
     */
    freightCalculationsMinimalCreate: (
      data: FreightCalculationMinimalParams[],
      params: RequestParams = {},
    ) =>
      this.request<FrcApiMinimalCalculationPlan[], HttpHelpersErrorResponse>({
        path: `/internal/freight/calculations/minimal`,
        method: "POST",
        body: data,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description Syncs the authenticated user's customer details (name, email, address) to Stripe. This ensures Stripe has the latest billing information for accurate tax calculations and invoicing.
     *
     * @tags Subscriptions
     * @name PaymentCustomerSyncCreate
     * @summary Sync customer details to Stripe
     * @request POST:/internal/payment/customer/sync
     * @secure
     */
    paymentCustomerSyncCreate: (params: RequestParams = {}) =>
      this.request<PaymentSyncCustomerResponse, string>({
        path: `/internal/payment/customer/sync`,
        method: "POST",
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description Retrieves all email preferences for the authenticated user
     *
     * @tags Email Preferences
     * @name PaymentEmailPreferencesList
     * @summary List user's email preferences
     * @request GET:/internal/payment/email-preferences
     * @secure
     */
    paymentEmailPreferencesList: (params: RequestParams = {}) =>
      this.request<PaymentEmailPreferencesListResponse, string>({
        path: `/internal/payment/email-preferences`,
        method: "GET",
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description Retrieves all market report groups the user has access to via their subscriptions, with current email preference status
     *
     * @tags Email Preferences
     * @name PaymentEmailPreferencesAvailableGroupsList
     * @summary List available market report groups for email preferences
     * @request GET:/internal/payment/email-preferences/available-groups
     * @secure
     */
    paymentEmailPreferencesAvailableGroupsList: (params: RequestParams = {}) =>
      this.request<PaymentAvailableGroupsListResponse, string>({
        path: `/internal/payment/email-preferences/available-groups`,
        method: "GET",
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description Enables email notifications for every market report group the current user has access to. Idempotent — safe to call multiple times.
     *
     * @tags Email Preferences
     * @name PaymentEmailPreferencesEnableAllPurchasedCreate
     * @summary Enable email for all purchased market report groups
     * @request POST:/internal/payment/email-preferences/enable-all-purchased
     * @secure
     */
    paymentEmailPreferencesEnableAllPurchasedCreate: (
      params: RequestParams = {},
    ) =>
      this.request<PaymentEnableAllPurchasedEmailPreferencesResponse, string>({
        path: `/internal/payment/email-preferences/enable-all-purchased`,
        method: "POST",
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description Retrieves the email preference for a specific market report group. Returns disabled if no preference exists.
     *
     * @tags Email Preferences
     * @name PaymentEmailPreferencesDetail
     * @summary Get email preference for a market report group
     * @request GET:/internal/payment/email-preferences/{marketReportGroupId}
     * @secure
     */
    paymentEmailPreferencesDetail: (
      marketReportGroupId: number,
      params: RequestParams = {},
    ) =>
      this.request<PaymentEmailPreferenceResponse, string>({
        path: `/internal/payment/email-preferences/${marketReportGroupId}`,
        method: "GET",
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description Creates or updates the email preference for a specific market report group. User must have an active subscription to the group.
     *
     * @tags Email Preferences
     * @name PaymentEmailPreferencesCreate
     * @summary Update email preference for a market report group
     * @request POST:/internal/payment/email-preferences/{marketReportGroupId}
     * @secure
     */
    paymentEmailPreferencesCreate: (
      marketReportGroupId: number,
      request: PaymentUpdateEmailPreferenceRequest,
      params: RequestParams = {},
    ) =>
      this.request<PaymentUpdateEmailPreferenceResponse, string>({
        path: `/internal/payment/email-preferences/${marketReportGroupId}`,
        method: "POST",
        body: request,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description Returns report access, email preference, actual send-list membership, and all report templates in priority order with the template this user is entitled to. Delivery and entitlement use the same priority assignment code path as the email subscriber endpoint.
     *
     * @tags Email Preferences
     * @name PaymentEmailPreferencesDeliveryStatusList
     * @summary Get effective market report email delivery status
     * @request GET:/internal/payment/email-preferences/{marketReportGroupId}/delivery-status
     * @secure
     */
    paymentEmailPreferencesDeliveryStatusList: (
      marketReportGroupId: number,
      params: RequestParams = {},
    ) =>
      this.request<PaymentEmailDeliveryStatusResponse, string>({
        path: `/internal/payment/email-preferences/${marketReportGroupId}/delivery-status`,
        method: "GET",
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Freight
     * @name FrcExchangeRatesForwardList
     * @request GET:/internal/frc/exchange_rates/forward
     */
    frcExchangeRatesForwardList: (params: RequestParams = {}) =>
      this.request<ExchangeRatesForwardLiveFRC[], any>({
        path: `/internal/frc/exchange_rates/forward`,
        method: "GET",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Freight
     * @name FrcExchangeRatesSpotList
     * @request GET:/internal/frc/exchange_rates/spot
     */
    frcExchangeRatesSpotList: (params: RequestParams = {}) =>
      this.request<ExchangeRatesLiveFRC[], any>({
        path: `/internal/frc/exchange_rates/spot`,
        method: "GET",
        ...params,
      }),

    /**
     * @description Get the default column names for the extended freight matrix.
     *
     * @tags Freight
     * @name FreightExtendedMatrixDefaultColumnsList
     * @request GET:/internal/freight/extended-matrix/default-columns
     */
    freightExtendedMatrixDefaultColumnsList: (params: RequestParams = {}) =>
      this.request<string[], any>({
        path: `/internal/freight/extended-matrix/default-columns`,
        method: "GET",
        format: "json",
        ...params,
      }),

    /**
     * @description Download the full extended freight matrix with base64url encoded dynamic column definitions as CSV.
     *
     * @tags Freight
     * @name FreightExtendedMatrixDownloadList
     * @request GET:/internal/freight/extended-matrix/download
     */
    freightExtendedMatrixDownloadList: (
      query: {
        /** Team ID. Use either teamId or jobId. */
        teamId?: number;
        /** Pre-calculate job ID. Use either teamId or jobId. */
        jobId?: string;
        /** Base64url encoded JSON array of column definition objects */
        columns: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<File, GinH>({
        path: `/internal/freight/extended-matrix/download`,
        method: "GET",
        query: query,
        ...params,
      }),

    /**
     * @description Preview an extended freight matrix with base64url encoded dynamic column definitions. Returns the first 10 records as JSON.
     *
     * @tags Freight
     * @name FreightExtendedMatrixPreviewList
     * @request GET:/internal/freight/extended-matrix/preview
     */
    freightExtendedMatrixPreviewList: (
      query: {
        /** Team ID. Use either teamId or jobId. */
        teamId?: number;
        /** Pre-calculate job ID. Use either teamId or jobId. */
        jobId?: string;
        /** Base64url encoded JSON array of column definition objects */
        columns: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<any[], GinH>({
        path: `/internal/freight/extended-matrix/preview`,
        method: "GET",
        query: query,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Bids and Offers
     * @name BidsAndOffersHistoricalList
     * @request GET:/internal/bids_and_offers/historical
     */
    bidsAndOffersHistoricalList: (
      query: {
        bid_offer_type?: string[];
        broker_id?: string[];
        /** @format date */
        date: string;
        limit?: number;
        offset?: number;
        origin_country_id?: number[];
        origin_country_location_collection_id?: number[];
        parity_id?: number[];
        port_country_id?: number[];
        port_id?: number[];
        port_location_collection_id?: number[];
        product_instance_id?: number[];
        protein_level?: number[];
        text_search?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<InternalBidAndOfferHistorical[], any>({
        path: `/internal/bids_and_offers/historical`,
        method: "GET",
        query: query,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Exchange Rates
     * @name ExchangeRatesHistoricalList
     * @request GET:/internal/exchange_rates/historical
     */
    exchangeRatesHistoricalList: (params: RequestParams = {}) =>
      this.request<ExchangeRatesHistoricalOverview[], any>({
        path: `/internal/exchange_rates/historical`,
        method: "GET",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Exchange Rates
     * @name ExchangeRatesHistoricalDetail
     * @request GET:/internal/exchange_rates/historical/{exchangeRateInstanceName}
     */
    exchangeRatesHistoricalDetail: (
      exchangeRateInstanceName: string,
      query?: {
        /** @format date */
        end_date?: string;
        /** @format date */
        start_date?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<ExchangeRateHistorical[], any>({
        path: `/internal/exchange_rates/historical/${exchangeRateInstanceName}`,
        method: "GET",
        query: query,
        ...params,
      }),

    /**
     * @description Retrieves all invoices for the authenticated user with optional filtering by status and limit
     *
     * @tags Payment Methods
     * @name PaymentInvoicesList
     * @summary List user's invoices
     * @request GET:/internal/payment/invoices
     * @secure
     */
    paymentInvoicesList: (
      query?: {
        /**
         * Maximum number of invoices to return (default: 50)
         * @example 50
         */
        limit?: number;
        /** Filter invoices by status (draft, open, paid, uncollectible, void) */
        status?: "draft" | "open" | "paid" | "uncollectible" | "void";
      },
      params: RequestParams = {},
    ) =>
      this.request<SubscriptionInvoicesResult, string>({
        path: `/internal/payment/invoices`,
        method: "GET",
        query: query,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description Download the results of a pre-calculate job as CSV. The file comes straight from the FRC engine (GET /api/v1/precalculate-jobs/{id}/results.csv), one row per stored standard route rate of the job.
     *
     * @tags Freight
     * @name FreightJobsDownloadList
     * @request GET:/internal/freight/jobs/{jobId}/download
     */
    freightJobsDownloadList: (jobId: string, params: RequestParams = {}) =>
      this.request<string, HttpHelpersErrorResponse>({
        path: `/internal/freight/jobs/${jobId}/download`,
        method: "GET",
        ...params,
      }),

    /**
     * @description The engine's status row for the job, placed on the matrix screens' progress bar: the engine's progress fills the first 80 points, a finished job waits at 85 until its rows reach the serving database, and 100 means the team can read them.
     *
     * @tags Freight
     * @name FreightJobsStatusList
     * @summary Progress of one pre-calculate job
     * @request GET:/internal/freight/jobs/{jobId}/status
     */
    freightJobsStatusList: (jobId: string, params: RequestParams = {}) =>
      this.request<FreightJobProgress, GinH>({
        path: `/internal/freight/jobs/${jobId}/status`,
        method: "GET",
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Access Logs
     * @name AccessLogsLatestUsedDetail
     * @request GET:/internal/access_logs/latest_used/{apiInstanceId}
     */
    accessLogsLatestUsedDetail: (
      apiInstanceId: number,
      params: RequestParams = {},
    ) =>
      this.request<GetLastUsageByApiRoute[], any>({
        path: `/internal/access_logs/latest_used/${apiInstanceId}`,
        method: "GET",
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Future Prices
     * @name FuturePricesLiveList
     * @request GET:/internal/future_prices/live
     */
    futurePricesLiveList: (params: RequestParams = {}) =>
      this.request<FuturePriceLive[], any>({
        path: `/internal/future_prices/live`,
        method: "GET",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Exchange Rates
     * @name ExchangeRatesLiveList
     * @request GET:/internal/exchange_rates/live
     */
    exchangeRatesLiveList: (params: RequestParams = {}) =>
      this.request<ExchangeRateLive[], any>({
        path: `/internal/exchange_rates/live`,
        method: "GET",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Exchange Rates
     * @name ExchangeRatesLiveDetail
     * @request GET:/internal/exchange_rates/live/{exchangeRateInstanceName}
     */
    exchangeRatesLiveDetail: (
      exchangeRateInstanceName: string,
      params: RequestParams = {},
    ) =>
      this.request<ExchangeRateLive, any>({
        path: `/internal/exchange_rates/live/${exchangeRateInstanceName}`,
        method: "GET",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Future Prices
     * @name FuturePricesLiveDetail
     * @request GET:/internal/future_prices/live/{futureInstanceName}
     */
    futurePricesLiveDetail: (
      futureInstanceName: string,
      params: RequestParams = {},
    ) =>
      this.request<FuturePriceLive[], any>({
        path: `/internal/future_prices/live/${futureInstanceName}`,
        method: "GET",
        ...params,
      }),

    /**
     * @description Returns users who should receive emails for a specific market report template within a group. Uses priority-based assignment (higher number = higher priority) where each user is assigned to their highest-priority template only. Paid subscribers have highest priority and receive the top-priority template. Platform subscribers are assigned based on their subscription template's priority mapping. Respects email preferences.
     *
     * @tags Market Report Subscriptions
     * @name PaymentMarketReportGroupsTemplatesEmailSubscribersList
     * @summary Get email subscribers for a market report template
     * @request GET:/internal/payment/market-report-groups/{marketReportGroupId}/templates/{marketReportTemplateId}/email-subscribers
     */
    paymentMarketReportGroupsTemplatesEmailSubscribersList: (
      marketReportGroupId: number,
      marketReportTemplateId: number,
      params: RequestParams = {},
    ) =>
      this.request<PaymentMarketReportSubscribersListResponse, string>({
        path: `/internal/payment/market-report-groups/${marketReportGroupId}/templates/${marketReportTemplateId}/email-subscribers`,
        method: "GET",
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Bids and Offers
     * @name BidsAndOffersMatchingList
     * @request GET:/internal/bids_and_offers/matching
     */
    bidsAndOffersMatchingList: (
      query: {
        bidOfferId: number;
      },
      params: RequestParams = {},
    ) =>
      this.request<InternalBidAndOfferMatchingResult[], any>({
        path: `/internal/bids_and_offers/matching`,
        method: "GET",
        query: query,
        ...params,
      }),

    /**
     * @description Retrieves all payment methods associated with the authenticated user's customer account
     *
     * @tags Payment Methods
     * @name PaymentMethodsList
     * @summary List user's payment methods
     * @request GET:/internal/payment/methods
     * @secure
     */
    paymentMethodsList: (params: RequestParams = {}) =>
      this.request<PaymentPaymentMethodsResponse, string>({
        path: `/internal/payment/methods`,
        method: "GET",
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description Attach a payment method to the customer's account. Creates customer if not exists. Rate limited to 10 requests per minute.
     *
     * @tags Payment Methods
     * @name PaymentMethodsAttachCreate
     * @summary Attach payment method
     * @request POST:/internal/payment/methods/attach
     * @secure
     */
    paymentMethodsAttachCreate: (
      request: PaymentPaymentMethodAttachRequest,
      params: RequestParams = {},
    ) =>
      this.request<PaymentPaymentMethodAttachResponse, string>({
        path: `/internal/payment/methods/attach`,
        method: "POST",
        body: request,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description Confirm a payment method setup after SetupIntent completion. The payment method is already attached by the payment provider when SetupIntent succeeds.
     *
     * @tags Payment Methods
     * @name PaymentMethodsConfirmCreate
     * @summary Confirm payment method setup
     * @request POST:/internal/payment/methods/confirm
     * @secure
     */
    paymentMethodsConfirmCreate: (
      request: PaymentPaymentMethodConfirmRequest,
      params: RequestParams = {},
    ) =>
      this.request<PaymentPaymentMethodConfirmResponse, string>({
        path: `/internal/payment/methods/confirm`,
        method: "POST",
        body: request,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description Create a SetupIntent for adding a new payment method. If customer is not synced to payment provider, it will be synced automatically.
     *
     * @tags Payment Methods
     * @name PaymentMethodsSetupIntentCreate
     * @summary Create setup intent
     * @request POST:/internal/payment/methods/setup-intent
     * @secure
     */
    paymentMethodsSetupIntentCreate: (params: RequestParams = {}) =>
      this.request<PaymentSetupIntentResponse, string>({
        path: `/internal/payment/methods/setup-intent`,
        method: "POST",
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description Remove (detach) a payment method from the customer's account
     *
     * @tags Payment Methods
     * @name PaymentMethodsDelete
     * @summary Delete payment method
     * @request DELETE:/internal/payment/methods/{id}
     * @secure
     */
    paymentMethodsDelete: (id: string, params: RequestParams = {}) =>
      this.request<PaymentMessageResponse, string>({
        path: `/internal/payment/methods/${id}`,
        method: "DELETE",
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description Set a payment method as the default for the customer. Rate limited to 20 requests per minute.
     *
     * @tags Payment Methods
     * @name PaymentMethodsSetDefaultCreate
     * @summary Set default payment method
     * @request POST:/internal/payment/methods/{id}/set-default
     * @secure
     */
    paymentMethodsSetDefaultCreate: (id: string, params: RequestParams = {}) =>
      this.request<PaymentMessageResponse, string>({
        path: `/internal/payment/methods/${id}/set-default`,
        method: "POST",
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Future Prices
     * @name FuturePricesNearestHistoricalList
     * @request GET:/internal/future_prices/nearest_historical
     */
    futurePricesNearestHistoricalList: (params: RequestParams = {}) =>
      this.request<FuturePriceNearestHistoricalOverview[], any>({
        path: `/internal/future_prices/nearest_historical`,
        method: "GET",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Future Prices
     * @name FuturePricesNearestHistoricalDetail
     * @request GET:/internal/future_prices/nearest_historical/{futureContractInstanceName}
     */
    futurePricesNearestHistoricalDetail: (
      futureContractInstanceName: string,
      query?: {
        /** @format date */
        end_date?: string;
        /** @format date */
        start_date?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<FuturePriceNearestHistorical[], any>({
        path: `/internal/future_prices/nearest_historical/${futureContractInstanceName}`,
        method: "GET",
        query: query,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Bids and Offers
     * @name BidsAndOffersPlatformList
     * @request GET:/internal/bids_and_offers/platform
     */
    bidsAndOffersPlatformList: (
      query: {
        bid_offer_type?: string;
        broker_id?: string[];
        /** @format date */
        date: string;
        limit?: number;
        offset?: number;
        origin_country_id?: number[];
        origin_country_location_collection_id?: number[];
        parity_id?: number[];
        port_country_id?: number[];
        port_id?: number[];
        port_location_collection_id?: number[];
        product_instance_id?: number[];
        protein_level?: number[];
        text_search?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<InternalBidAndOfferPlatform[], any>({
        path: `/internal/bids_and_offers/platform`,
        method: "GET",
        query: query,
        ...params,
      }),

    /**
     * @description Creates a platform subscription using a stored payment method (in-page checkout, no redirect)
     *
     * @tags Payment
     * @name PaymentPlatformCheckoutCreateWithPaymentCreate
     * @summary Create platform subscription with payment
     * @request POST:/internal/payment/platform-checkout/create-with-payment
     * @secure
     */
    paymentPlatformCheckoutCreateWithPaymentCreate: (
      request: PaymentCreatePlatformSubscriptionWithPaymentParams,
      params: RequestParams = {},
    ) =>
      this.request<SubscriptionCreateWithPaymentResult, string>({
        path: `/internal/payment/platform-checkout/create-with-payment`,
        method: "POST",
        body: request,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description Asks the FRC engine to pre-calculate the given matrices. Spot jobs need only the matrix ids, historical ones also the date range and granularity.
     *
     * @tags Freight
     * @name FreightPrecalculateCreate
     * @summary Start a pre-calculate job
     * @request POST:/internal/freight/precalculate
     */
    freightPrecalculateCreate: (
      body: FrcApiPrecalculateRequest,
      params: RequestParams = {},
    ) =>
      this.request<FrcApiPrecalculateSuccessResponse, GinH>({
        path: `/internal/freight/precalculate`,
        method: "POST",
        body: body,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description Asks the engine to (re)calculate the routes of the team's enabled matrix groups against a prior full pre-calculate job. One partial job per team runs at a time: a 409 carries the running job's id in data.jobId.
     *
     * @tags Freight
     * @name FreightPrecalculatePartialCreate
     * @summary Start a partial pre-calculate job for a team
     * @request POST:/internal/freight/precalculate/partial
     */
    freightPrecalculatePartialCreate: (
      body: FreightPrecalculatePartialRequest,
      params: RequestParams = {},
    ) =>
      this.request<
        FrcApiPartialTriggerResponse,
        GinH | FrcApiPartialTriggerResponse
      >({
        path: `/internal/freight/precalculate/partial`,
        method: "POST",
        body: body,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Market Information Publishing
     * @name MarketInformationProjectionUpdate
     * @summary Publish a market-information post to the serving database
     * @request PUT:/internal/market-information/projection
     */
    marketInformationProjectionUpdate: (
      data: MarketInformationPublishRequest,
      params: RequestParams = {},
    ) =>
      this.request<void, void>({
        path: `/internal/market-information/projection`,
        method: "PUT",
        body: data,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Market Information Publishing
     * @name MarketInformationProjectionPruneCreate
     * @summary Remove serving posts of a kind that are not in Payload
     * @request POST:/internal/market-information/projection/prune
     */
    marketInformationProjectionPruneCreate: (
      data: MarketInformationPruneRequest,
      params: RequestParams = {},
    ) =>
      this.request<MarketInformationPruneResponse, void>({
        path: `/internal/market-information/projection/prune`,
        method: "POST",
        body: data,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Market Information Publishing
     * @name MarketInformationProjectionDelete
     * @summary Remove a market-information post from the serving database
     * @request DELETE:/internal/market-information/projection/{kind}/{id}
     */
    marketInformationProjectionDelete: (
      kind: "marketInformation" | "dailySummary",
      id: number,
      params: RequestParams = {},
    ) =>
      this.request<void, void>({
        path: `/internal/market-information/projection/${kind}/${id}`,
        method: "DELETE",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Auth
     * @name UserInfoCachePurgeDelete
     * @request DELETE:/internal/user-info-cache/purge
     */
    userInfoCachePurgeDelete: (params: RequestParams = {}) =>
      this.request<void, any>({
        path: `/internal/user-info-cache/purge`,
        method: "DELETE",
        ...params,
      }),

    /**
     * @description Which load and discharge port and vessel size combinations resolve a port cost, for the customer freight matrix editor. The sales equivalent under /internal_direct/frc_matrix takes a db version; this one is pinned to the latest.
     *
     * @tags Freight
     * @name FreightRouteAvailabilityCreate
     * @summary Port cost availability of a matrix
     * @request POST:/internal/freight/route-availability
     */
    freightRouteAvailabilityCreate: (
      body: FreightRouteAvailabilityRequest,
      params: RequestParams = {},
    ) =>
      this.request<GinH, GinH>({
        path: `/internal/freight/route-availability`,
        method: "POST",
        body: body,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description Set a VAT number (tax ID) for the authenticated user's customer account. This removes any existing VAT numbers and sets the new one if provided. An empty VAT number will remove all VAT numbers from the account.
     *
     * @tags Payment Methods
     * @name PaymentSetVatNumberCreate
     * @summary Set VAT number
     * @request POST:/internal/payment/set-vat-number
     * @secure
     */
    paymentSetVatNumberCreate: (
      request: PaymentSetVatNumberRequest,
      params: RequestParams = {},
    ) =>
      this.request<PaymentSetVatNumberResponse, string>({
        path: `/internal/payment/set-vat-number`,
        method: "POST",
        body: request,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description Fetches standard route rates by voyage IDs from the latest pre-calculation job. If a route is not available, it will be returned in the errors array. When a voyage ID matches multiple routes, the system picks the one with minimal overrides and returns alternatives in the alternative_rates field.
     *
     * @tags Freight
     * @name FreightStandardRatesByVoyageIdsCreate
     * @request POST:/internal/freight/standard-rates/by-voyage-ids
     */
    freightStandardRatesByVoyageIdsCreate: (
      data: GetStandardRatesByVoyageIDsRequest,
      params: RequestParams = {},
    ) =>
      this.request<GetStandardRatesByVoyageIDsResponse, any>({
        path: `/internal/freight/standard-rates/by-voyage-ids`,
        method: "POST",
        body: data,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description Retrieves detailed information about a specific subscription for the authenticated user
     *
     * @tags Subscriptions
     * @name PaymentSubscriptionDetail
     * @summary Get subscription details
     * @request GET:/internal/payment/subscription/{id}
     * @secure
     */
    paymentSubscriptionDetail: (id: number, params: RequestParams = {}) =>
      this.request<SubscriptionSubscriptionData, string>({
        path: `/internal/payment/subscription/${id}`,
        method: "GET",
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description Cancels a subscription for the authenticated user. By default, cancels at the end of the billing period. Can optionally cancel immediately.
     *
     * @tags Subscriptions
     * @name PaymentSubscriptionCancelCreate
     * @summary Cancel a subscription
     * @request POST:/internal/payment/subscription/{id}/cancel
     * @secure
     */
    paymentSubscriptionCancelCreate: (
      id: number,
      request: PaymentCancelSubscriptionRequest,
      params: RequestParams = {},
    ) =>
      this.request<SubscriptionCancelSubscriptionResult, string>({
        path: `/internal/payment/subscription/${id}/cancel`,
        method: "POST",
        body: request,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description Applies the subscription changes (plan upgrade/downgrade). This will immediately update the subscription and may charge/credit the customer based on proration.
     *
     * @tags Subscriptions
     * @name PaymentSubscriptionConfirmChangeCreate
     * @summary Confirm changes to a subscription
     * @request POST:/internal/payment/subscription/{id}/confirm-change
     * @secure
     */
    paymentSubscriptionConfirmChangeCreate: (
      id: number,
      request: PaymentConfirmSubscriptionChangeRequest,
      params: RequestParams = {},
    ) =>
      this.request<SubscriptionConfirmSubscriptionChangeResult, string>({
        path: `/internal/payment/subscription/${id}/confirm-change`,
        method: "POST",
        body: request,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description Previews the changes that will be applied to a subscription
     *
     * @tags Subscriptions
     * @name PaymentSubscriptionPreviewChangeCreate
     * @summary Preview changes to a subscription
     * @request POST:/internal/payment/subscription/{id}/preview-change
     * @secure
     */
    paymentSubscriptionPreviewChangeCreate: (
      id: number,
      request: SubscriptionPreviewSubscriptionChange,
      params: RequestParams = {},
    ) =>
      this.request<SubscriptionSubscriptionChangePreview, string>({
        path: `/internal/payment/subscription/${id}/preview-change`,
        method: "POST",
        body: request,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description Reactivates a subscription that was scheduled to cancel at period end. This removes the cancellation and keeps the subscription active.
     *
     * @tags Subscriptions
     * @name PaymentSubscriptionReactivateCreate
     * @summary Reactivate a canceled subscription
     * @request POST:/internal/payment/subscription/{id}/reactivate
     * @secure
     */
    paymentSubscriptionReactivateCreate: (
      id: number,
      params: RequestParams = {},
    ) =>
      this.request<SubscriptionReactivateSubscriptionResult, string>({
        path: `/internal/payment/subscription/${id}/reactivate`,
        method: "POST",
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description Retrieves all subscriptions for the authenticated user with optional filtering to include inactive subscriptions
     *
     * @tags Subscriptions
     * @name PaymentSubscriptionsList
     * @summary List user's subscriptions
     * @request GET:/internal/payment/subscriptions
     * @secure
     */
    paymentSubscriptionsList: (
      query?: {
        /**
         * Include inactive subscriptions (default: false)
         * @example false
         */
        includeInactive?: boolean;
      },
      params: RequestParams = {},
    ) =>
      this.request<SubscriptionSubscriptionData[], string>({
        path: `/internal/payment/subscriptions`,
        method: "GET",
        query: query,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description Creates a new subscription for the authenticated user with immediate payment processing. Requires a pre-configured payment method ID.
     *
     * @tags Subscriptions
     * @name PaymentSubscriptionsCreateWithPaymentCreate
     * @summary Create subscription with payment
     * @request POST:/internal/payment/subscriptions/create-with-payment
     * @secure
     */
    paymentSubscriptionsCreateWithPaymentCreate: (
      request: SubscriptionCreateWithPaymentParams,
      params: RequestParams = {},
    ) =>
      this.request<SubscriptionCreateWithPaymentResult, string>({
        path: `/internal/payment/subscriptions/create-with-payment`,
        method: "POST",
        body: request,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description Previews the costs for a new subscription without creating it. Shows pricing breakdown, subtotals, and VAT/tax information.
     *
     * @tags Subscriptions
     * @name PaymentSubscriptionsPreviewCostsCreate
     * @summary Preview subscription costs
     * @request POST:/internal/payment/subscriptions/preview-costs
     * @secure
     */
    paymentSubscriptionsPreviewCostsCreate: (
      request: SubscriptionPreviewSubscriptionChange,
      params: RequestParams = {},
    ) =>
      this.request<SubscriptionSubscriptionCostPreview, string>({
        path: `/internal/payment/subscriptions/preview-costs`,
        method: "POST",
        body: request,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description Syncs products with Payment Provider
     *
     * @tags Pricing Admin
     * @name ProviderSyncProductsCreate
     * @summary Trigger provider sync for products
     * @request POST:/internal/provider/sync/products
     */
    providerSyncProductsCreate: (
      data: SubscriptionProviderSyncInstructions,
      params: RequestParams = {},
    ) =>
      this.request<string, any>({
        path: `/internal/provider/sync/products`,
        method: "POST",
        body: data,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description Triggers a PostgreSQL NOTIFY on the specified channel with a JSON payload and timestamp. The notification is logged and sent to the database.
     *
     * @tags Notifications
     * @name NotificationsTriggerDbCreate
     * @summary Trigger database notification via channel
     * @request POST:/internal/notifications/trigger/db/{channel}
     */
    notificationsTriggerDbCreate: (
      channel: string,
      payload: GinH,
      params: RequestParams = {},
    ) =>
      this.request<
        NotificationsNotificationSuccessResponse,
        HttpHelpersErrorResponse
      >({
        path: `/internal/notifications/trigger/db/${channel}`,
        method: "POST",
        body: payload,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description Broadcasts a message to all connected sales panel WebSocket clients with a JSON payload
     *
     * @tags Notifications
     * @name NotificationsTriggerSalesPanelCreate
     * @summary Trigger sales panel notification
     * @request POST:/internal/notifications/trigger/sales_panel
     */
    notificationsTriggerSalesPanelCreate: (
      payload: any,
      params: RequestParams = {},
    ) =>
      this.request<
        NotificationsNotificationSuccessResponse,
        HttpHelpersErrorResponse
      >({
        path: `/internal/notifications/trigger/sales_panel`,
        method: "POST",
        body: payload,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Bids and Offers
     * @name BidsAndOffersTriggerChangeAllList
     * @request GET:/internal/bids_and_offers/trigger_change_all
     */
    bidsAndOffersTriggerChangeAllList: (params: RequestParams = {}) =>
      this.request<void, any>({
        path: `/internal/bids_and_offers/trigger_change_all`,
        method: "GET",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Auth
     * @name UserInfoCacheUserDelete
     * @request DELETE:/internal/user-info-cache/user/{id}
     */
    userInfoCacheUserDelete: (id: string, params: RequestParams = {}) =>
      this.request<void, ErrorResponse>({
        path: `/internal/user-info-cache/user/${id}`,
        method: "DELETE",
        ...params,
      }),

    /**
     * No description
     *
     * @tags reCAPTCHA
     * @name RecaptchaVerifyCreate
     * @summary Verify a reCAPTCHA Enterprise token
     * @request POST:/internal/recaptcha/verify
     */
    recaptchaVerifyCreate: (
      request: RecaptchaVerifyRequest,
      params: RequestParams = {},
    ) =>
      this.request<RecaptchaVerifyResult, HttpHelpersErrorResponse>({
        path: `/internal/recaptcha/verify`,
        method: "POST",
        body: request,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description The FRC engine's vessel types of the latest db version, for the sales matrix pages rendered on the server.
     *
     * @tags Freight
     * @name FreightVesselsList
     * @summary List vessel sizes
     * @request GET:/internal/freight/vessels
     */
    freightVesselsList: (params: RequestParams = {}) =>
      this.request<FrcApiVesselResponse[], GinH>({
        path: `/internal/freight/vessels`,
        method: "GET",
        format: "json",
        ...params,
      }),

    /**
     * @description Lists webhook events with optional filters
     *
     * @tags Payment Webhooks Admin
     * @name AdminWebhooksList
     * @summary List webhook events
     * @request GET:/internal/admin/webhooks
     * @secure
     */
    adminWebhooksList: (
      query?: {
        /** Filter by provider */
        provider?: string;
        /** Filter by status */
        status?: string;
        /** Filter by event type */
        eventType?: string;
        /** Limit results (default 50) */
        limit?: number;
        /** Offset for pagination */
        offset?: number;
      },
      params: RequestParams = {},
    ) =>
      this.request<PaymentWebhooksListWebhooksResponse, string>({
        path: `/internal/admin/webhooks`,
        method: "GET",
        query: query,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description Returns statistics about webhook events
     *
     * @tags Payment Webhooks Admin
     * @name AdminWebhooksStatsList
     * @summary Get webhook statistics
     * @request GET:/internal/admin/webhooks/stats
     * @secure
     */
    adminWebhooksStatsList: (
      query?: {
        /** Filter by provider */
        provider?: string;
        /** Hours to look back (default 24) */
        hours?: number;
      },
      params: RequestParams = {},
    ) =>
      this.request<PaymentWebhookEventStats, string>({
        path: `/internal/admin/webhooks/stats`,
        method: "GET",
        query: query,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description Retrieves a single webhook event by ID
     *
     * @tags Payment Webhooks Admin
     * @name AdminWebhooksDetail
     * @summary Get webhook event
     * @request GET:/internal/admin/webhooks/{id}
     * @secure
     */
    adminWebhooksDetail: (id: number, params: RequestParams = {}) =>
      this.request<PaymentWebhookStoredWebhookEvent, string>({
        path: `/internal/admin/webhooks/${id}`,
        method: "GET",
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description Manually triggers retry of a failed webhook event
     *
     * @tags Payment Webhooks Admin
     * @name AdminWebhooksRetryCreate
     * @summary Retry webhook event
     * @request POST:/internal/admin/webhooks/{id}/retry
     * @secure
     */
    adminWebhooksRetryCreate: (id: number, params: RequestParams = {}) =>
      this.request<Record<string, string>, string>({
        path: `/internal/admin/webhooks/${id}/retry`,
        method: "POST",
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description Triggers an incoming API notification on the specified channel with a JSON payload
     *
     * @tags Notifications
     * @name NotificationsCreate
     * @summary Trigger notification via channel
     * @request POST:/internal/notifications/{channel}
     */
    notificationsCreate: (
      channel: string,
      payload: any,
      params: RequestParams = {},
    ) =>
      this.request<
        NotificationsNotificationSuccessResponse,
        HttpHelpersErrorResponse
      >({
        path: `/internal/notifications/${channel}`,
        method: "POST",
        body: payload,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Jobs
     * @name JobsProgressList
     * @summary Get job progress, it updates the Job table in the appdb aswell
     * @request GET:/internal/jobs/{id}/progress
     */
    jobsProgressList: (id: number, params: RequestParams = {}) =>
      this.request<JobsJobProgressResponse, any>({
        path: `/internal/jobs/${id}/progress`,
        method: "GET",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Bids and Offers
     * @name BidsAndOffersTriggerChangeUpdate
     * @request PUT:/internal/bids_and_offers/{id}/trigger_change
     */
    bidsAndOffersTriggerChangeUpdate: (
      id: string,
      params: RequestParams = {},
    ) =>
      this.request<void, any>({
        path: `/internal/bids_and_offers/${id}/trigger_change`,
        method: "PUT",
        ...params,
      }),

    /**
     * @description Endpoint for receiving webhook events from payment providers (Stripe, etc.)
     *
     * @tags Payment Webhooks
     * @name WebhooksCreate
     * @summary Receive payment provider webhook
     * @request POST:/internal/webhooks/{provider}
     */
    webhooksCreate: (provider: string, params: RequestParams = {}) =>
      this.request<string, string>({
        path: `/internal/webhooks/${provider}`,
        method: "POST",
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Jobs
     * @name JobsCreate
     * @summary Start a job
     * @request POST:/internal/jobs/{type}/{identifier}
     */
    jobsCreate: (
      type: string,
      identifier: string,
      payload: JobsStartJobPayload,
      params: RequestParams = {},
    ) =>
      this.request<JobsJobProgressResponse, any>({
        path: `/internal/jobs/${type}/${identifier}`,
        method: "POST",
        body: payload,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Auth
     * @name UserInfoDetail
     * @request GET:/internal/user-info/{userId}
     */
    userInfoDetail: (userId?: string, params: RequestParams = {}) =>
      this.request<AuthUserInfo, ErrorResponse>({
        path: `/internal/user-info/${userId}`,
        method: "GET",
        ...params,
      }),
  };
}
